import { AfterViewChecked, AfterViewInit, Component, ElementRef, HostListener, Input, input, OnInit, ViewChild } from '@angular/core';
import { GLTFLoader ,STLExporter,TextGeometry,FontLoader, OrbitControls,LineMaterial,LineSegmentsGeometry,Wireframe   } from 'three-stdlib';
import * as THREE from 'three';
import { CSG } from 'three-csg-ts';
import { ModelService } from '../model.service';
import { LanguageService } from 'src/app/_services/language.service';
import * as JSPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { file } from '@rxweb/reactive-form-validators';
import { ApiService } from 'src/app/_services/api.service';
import { LunghezzeAngolariService } from 'src/app/_services/lunghezze-angolari.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-model-viewer',
  standalone: false,
  templateUrl: './model-viewer.component.html',
  styleUrl: './model-viewer.component.scss',
  providers:[MessageService]
   
})
export class ModelViewerComponent implements OnInit {
  @Input('configurazioneCelle') configurazioneCelle:any=null;
  showDialog:boolean=false;
  originalSizeW:number=0;
  originalSizeH:number=0;
  @ViewChild('rendererContainerObj', { static: true })
  rendererContainerObj!: ElementRef;
  scene!: THREE.Scene;
  camera!: THREE.PerspectiveCamera;
  renderer!: THREE.WebGLRenderer;
  loader!: GLTFLoader;
  wireframe:any;
  mesh:any=null;
  fontName='assets/fonts/droid/droid_sans_mono_regular.typeface.json';
  fontProperties:any={};
  fontColor=0xFF0000;

  cellaperLabel:number=0; // indica per le multicelle a quale cella associare la stampa delle misure (cella piu in alot o piu a sinitra)
  sceneBackground=0xcccccc
  



  group:any=null;
  

 
  // PDF
   pdf:any;
   pdfProp:number=0.1;

  controls!: OrbitControls; // Add this line for OrbitControls
  sizesScreen = {
    w: 800,
    h: 800,
  };
  raggioSmussoAngolare=1.5;
  latoAngolare=7.5;

  

  porta:any={};
  
  constructor(
    private lunghezzeAngolariService: LunghezzeAngolariService,
    private apiService: ApiService,
    private messageService: MessageService,
    
    private mS:ModelService,   public lang:LanguageService) {}

  

  ngOnInit() {
   const loader = new FontLoader();
    loader.load(this.fontName,  ( font ) =>{
      this.fontProperties= {
        size: 5,
        height: 0.025,
        curveSegments: 8,
        bevelEnabled: true,
        bevelThickness: 0.00125,
        bevelSize: 0.00025,
        bevelOffset: 0,
      } 
      this.fontProperties.font=font;
      this.init();  
      this.animate();
    });
  }


  init(){
    
    this.camera = new THREE.PerspectiveCamera();
   // this.camera.position.set(-400, 100, -400);
    this.camera.translateY(200);
    this.camera.translateX(-400);
     this.camera.translateZ(-400);
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(this.sceneBackground);
  
    //this.scene.add(new THREE.HemisphereLight(0xffffcc, 0x19bbdc, 1));

    this.renderer = new THREE.WebGLRenderer( { antialias: true } );
   // this.renderer.setClearColor( 0x000000, 0.0 );
  
    // this.renderer.setClearColor(0xffffff, 0);
    this.rendererContainerObj.nativeElement.appendChild(
      this.renderer.domElement
    );
    let w= window.innerWidth-50;
    let h= window.innerHeight ;
    this.camera.aspect = w / h;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize( w, h );

    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.enablePan=true;
    var axesHelper = new THREE.AxesHelper( 50 );
    this.scene.add( axesHelper );
  
    
  }

  
  
  creaCappuccio(treVie=false){
  
    var shape1 = new THREE.Shape();
    shape1.lineTo(this.latoAngolare,0);
    shape1.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
    shape1.lineTo(this.latoAngolare,0);
    shape1.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
    shape1.absarc( this.latoAngolare-this.raggioSmussoAngolare, this.latoAngolare-this.raggioSmussoAngolare, this.raggioSmussoAngolare, 0,0.5* Math.PI,  false );
    shape1.lineTo(0,this.latoAngolare);
    shape1.lineTo(this.latoAngolare-this.raggioSmussoAngolare,this.latoAngolare);
    shape1.lineTo(0,this.latoAngolare);


    const x2 = new THREE.ShapeGeometry( shape1 );



    var shape = new THREE.Shape();
    shape.absarc( 0, 0, this.raggioSmussoAngolare, 0.5* Math.PI,0,  true );
    shape.lineTo(this.latoAngolare,0);
    shape.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
    shape.lineTo(this.latoAngolare,0);
    shape.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
    shape.absarc( this.latoAngolare-this.raggioSmussoAngolare, this.latoAngolare-this.raggioSmussoAngolare, this.raggioSmussoAngolare, 0,0.5* Math.PI,  false );
    shape.lineTo(0,this.latoAngolare);
    shape.lineTo(this.latoAngolare-this.raggioSmussoAngolare,this.latoAngolare);
    shape.lineTo(0,this.latoAngolare);


    const x = new THREE.ShapeGeometry( shape );
    let y= x.clone();
    let z=x.clone();
    let x3=x2.clone();


    y.rotateY(Math.PI);
    x.rotateY(-1*Math.PI/2);
    x2.rotateY(-1*Math.PI/2);
    x2.translate(-1*this.latoAngolare+this.raggioSmussoAngolare,0,0);
    x3.rotateY(-1*Math.PI);
    x3.translate(0,0,this.latoAngolare-this.raggioSmussoAngolare);
    z.rotateX(Math.PI/2);
    z.rotateY(1.5*Math.PI);
    let z2= x2.clone();

    z2.translate(2*this.latoAngolare-2*this.raggioSmussoAngolare,0,0);

    z2.rotateZ(Math.PI/2);

    var mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
    if(treVie){
      mat = new THREE.LineBasicMaterial( { color: 0x00aa00, linewidth: 1 } );
    }

    var geox = new THREE.EdgesGeometry( x,30 ); // or WireframeGeometry( geometry )
    let  wirex= new THREE.LineSegments( geox, mat );
    wirex.updateMatrix();

    var geoy = new THREE.EdgesGeometry( y,30 ); // or WireframeGeometry( geometry )
    let  wirey= new THREE.LineSegments( geoy, mat );
    wirey.updateMatrix();

    var geoz = new THREE.EdgesGeometry( z,30 ); // or WireframeGeometry( geometry )
    let  wirez= new THREE.LineSegments( geoz, mat );
    wirey.updateMatrix();

    var geox2 = new THREE.EdgesGeometry( x2,30 ); // or WireframeGeometry( geometry )
    let  wirex2= new THREE.LineSegments( geox2, mat );
    wirex2.updateMatrix();


    var geox3 = new THREE.EdgesGeometry( x3,30 ); // or WireframeGeometry( geometry )
    let  wirex3= new THREE.LineSegments( geox3, mat );
    wirex3.updateMatrix();

    var geoz2 = new THREE.EdgesGeometry( z2,30 ); // or WireframeGeometry( geometry )
    let  wirez2= new THREE.LineSegments( geoz2, mat );
    wirez2.updateMatrix();


    const group = new THREE.Group();
    group.add( wirex );
    group.add( wirey );
    group.add( wirez );
    group.add( wirex2 );
    group.add( wirex3 );

    group.add( wirez2 );
    return group;
  }

  pushAngolare(lunghezzeAngolare:number,lato:string='',pavsof:string='',treVie=false){
    let lung=0;
    let pos=0;
    let lunghezzAng= [20,27,31,40,60,80,100,120,140,160,180,200,220,240,260,280,300,320];
    let combAng:any={}; 
    let input:any=[]; 
    let currentAng:any=[];
    let ca:any={};
    const angNormale='a00';
    const ang3Vie='b03';
    let codang=angNormale;



//    if(pavsof!='' && this.isLatoRaccordato(lato)== null){
    //  return;
  //  }
    if(this.mS.checkCombinateLatoDaNonDisegnare(lato)){
       return ;
    }

  //  if(this.mS.checkCombinateLatoDaNonDisegnare(lato,true)){
    if(treVie){
      codang=ang3Vie;

    }
   
    

    const dataAngolari = this.lunghezzeAngolariService.getDataAngolari();
    let found = dataAngolari.find((x: any) => x.lunghezza == lunghezzeAngolare);
    // Orizzontali pav/sof: se manca la misura esatta → prima lunghezza di catalogo appena più grande
    if (!found && (pavsof === 'pav' || pavsof === 'sof')) {
      found = dataAngolari.find((x: any) => x.lunghezza > lunghezzeAngolare);
    }
    // fallback legacy (es. verticali): +9
    if (!found) {
      found = dataAngolari.find((x: any) => x.lunghezza == lunghezzeAngolare + 9);
    }
    if (found?.composizione?.length) {
      input = [...found.composizione];
      if (this.mS.cellaDati.spessore == 13) {
        input.forEach((lungh: any, ind: number) => {
          if (lungh % 40 !== 0) {
            input[ind] += 20;
          }
        });
      }
    }
    

    combAng = Object.values(
      input.reduce((acc:any, segment:any) => {
        if (!acc[segment]) {
          acc[segment] = { segment: segment, count: 0 };
        }
        acc[segment].count++;
        return acc;
      }, {} as Record<number, any>)
    );

    if(!combAng){
       return null;
    }
        
    let codcal='K5';
    if(this.mS.cellaDati.finituraangolari!='STANDARD'){
      codcal='K6';
    }


    combAng.forEach((v:any,ind:number)=>{
      if(ind>0 || v.count>1)
      this.mS.cellaDati.numCoprifilo+=v.count==1 ? 1:v.count-1;
    });
    
    combAng.forEach((curp:any)=>{
      lung=curp.segment;
      if(lung==31 || lung==27){
        lung=40;
      }
    
      for(let q:number=0;q<curp.count;q++){
         ca={
            name:codcal+this.mS.objCella.spessore.toString().padStart(2,"0")+lung.toString().padStart(3,"0")+codang,
            lunghezza:curp.segment,
            pos:pos
          };              
        this.mS.objCella.angolari.push(ca);
        currentAng.push(ca);      

        
        pos+=lung;
      }
    });
    return currentAng;
  }

  isLatoRaccordato(lato:string){

   

      let isCollegato=false;
      let isGiaInserito=false;
      const indCella = this.configurazioneCelle.elencoCelle.findIndex((ce:any) => ce.id === this.mS.cellaDati.id);
   
      if(this.mS.checkCombinateLatoDaNonDisegnare(lato)){
          return null;
      }
      
      return false;

      this.mS.cellaDati.celleCollegate.forEach((c:any)=>{
        const indCellaColl = this.configurazioneCelle.elencoCelle.findIndex((ce:any) => ce.id === c.cellaCollegataId);
       
        if(c.latocollegato=='lato_retro' && (lato=='d' || lato=='wd' || lato=='pav_retro')){
         if(c.tipoCollegamento!='combinate' && indCellaColl<indCella){
            isGiaInserito=true;
          } else {
             isCollegato=true;
          }
        }
        if(c.latocollegato=='lato_fronte' && (lato=='0' || lato=='w' || lato=='pav_fronte')){
          if(c.tipoCollegamento!='combinate' && indCellaColl<indCella){
            isGiaInserito=true;
          } else {
             isCollegato=true;
          }
        }
        if(c.latocollegato=='lato_ds' && (lato=='w' || lato=='wd' || lato=='pav_ds')){
          if(c.tipoCollegamento!='combinate' && indCellaColl<indCella){
            isGiaInserito=true;
          } else {
             isCollegato=true;
          }
        }
         if(c.latocollegato=='lato_sn' && (lato=='0' || lato=='d' || lato=='pav_sn')){
          if(c.tipoCollegamento!='combinate' && indCellaColl<indCella){
            isGiaInserito=true;
           } else {
             isCollegato=true;
          }
        }
         if(c.tipoCollegamento=='unite'){
          isCollegato=false;
          isGiaInserito=false;
        }
      });  

      if(isGiaInserito){
        return null;
      } else {
         return isCollegato;
      }
     

  }

  creaAngolare2(lunghezzeAngolare:number,lato:string='',pavsof='',treVie=false){
    let ang:any=this.pushAngolare(lunghezzeAngolare,lato,pavsof,treVie);
    let anggroup:any=[];
    if(!ang){
      return [];
    }

    ang.forEach((a:any)=>{
      let shape = new THREE.Shape();
      shape.absarc( 0, 0, this.raggioSmussoAngolare, 0.5* Math.PI,0,  true );
      shape.lineTo(this.latoAngolare,0);
      shape.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
      shape.lineTo(this.latoAngolare,0);
      shape.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
      shape.absarc( this.latoAngolare-this.raggioSmussoAngolare, this.latoAngolare-this.raggioSmussoAngolare, this.raggioSmussoAngolare, 0,0.5* Math.PI,  false );
      shape.lineTo(0,this.latoAngolare);
      shape.lineTo(this.latoAngolare-this.raggioSmussoAngolare,this.latoAngolare);
      shape.lineTo(0,this.latoAngolare);
      let geoShape = new THREE.ShapeGeometry( shape );

      let shape1=shape.clone();
      let geoShape1 = new THREE.ShapeGeometry( shape1 );
      geoShape1.translate(0,0,a.lunghezza);
      let shapeQ = new THREE.Shape();
      shapeQ.lineTo(0,a.lunghezza);
      shapeQ.lineTo(this.latoAngolare-this.raggioSmussoAngolare,a.lunghezza);
      shapeQ.lineTo(this.latoAngolare-this.raggioSmussoAngolare,0);
      
      let geoShapeQ = new THREE.ShapeGeometry( shapeQ );
      geoShapeQ.rotateX(Math.PI/2);
      geoShapeQ.translate(this.raggioSmussoAngolare,0,0);

      let shapeQ1=shapeQ.clone();
      let geoShapeQ1 = new THREE.ShapeGeometry( shapeQ1 );
      geoShapeQ1.rotateX(Math.PI/2);
      geoShapeQ1.translate(0,this.latoAngolare,0);

      let shapeQ2=shapeQ.clone();
      let geoShapeQ2 = new THREE.ShapeGeometry( shapeQ2 );
      geoShapeQ2.rotateX(Math.PI/2);
      geoShapeQ2.rotateZ(Math.PI/2);
      geoShapeQ2.translate(0,this.raggioSmussoAngolare,0);

      let shapeQ3=shapeQ.clone();
      let geoShapeQ3 = new THREE.ShapeGeometry( shapeQ3 );
      geoShapeQ3.rotateX(Math.PI/2);
      geoShapeQ3.rotateZ(Math.PI/2);
      geoShapeQ3.translate(this.latoAngolare,0,0);
      let mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
      if(treVie){
       mat = new THREE.LineBasicMaterial( { color: 0x00aa00, linewidth: 1 } );
      } 

      let geox = new THREE.EdgesGeometry( geoShape,30 ); // or WireframeGeometry( geometry )
      let wire= new THREE.LineSegments( geox, mat );
      wire.updateMatrix();
      let geox1 = new THREE.EdgesGeometry( geoShape1,30 ); // or WireframeGeometry( geometry )
      let wire1= new THREE.LineSegments( geox1, mat );
      wire1.updateMatrix();
      let geoxQ = new THREE.EdgesGeometry( geoShapeQ,30 ); // or WireframeGeometry( geometry )
      let wireQ= new THREE.LineSegments( geoxQ, mat );
      wireQ.updateMatrix();
      let geoxQ1= new THREE.EdgesGeometry( geoShapeQ1,30 ); // or WireframeGeometry( geometry )
      let wireQ1= new THREE.LineSegments( geoxQ1, mat );
      wireQ1.updateMatrix();
      let geoxQ2= new THREE.EdgesGeometry( geoShapeQ2,30 ); // or WireframeGeometry( geometry )
      let wireQ2= new THREE.LineSegments( geoxQ2, mat );
      wireQ2.updateMatrix();
      let geoxQ3= new THREE.EdgesGeometry( geoShapeQ3,30 ); // or WireframeGeometry( geometry )
      let wireQ3= new THREE.LineSegments( geoxQ3, mat );
      wireQ2.updateMatrix();
      let group = new THREE.Group();
      group.add( wire );
      group.add( wire1 );
      group.add( wireQ );
      group.add( wireQ1 );
      group.add( wireQ2 );
      group.add( wireQ3 );
      if(pavsof=='pav'){
        if(lato=='pav_fronte'){
          group.translateZ(a.pos);
        }
        if(lato=='pav_retro' ){
          group.translateZ(-1*a.pos);
        }
        if(lato=='pav_ds' ){
          group.translateX(-1*a.pos);
        }
        if( lato=='pav_sn'){
          group.translateX(-1*a.pos);
        }
      } 
      if(pavsof=='sof'){
        if(lato=='pav_fronte'){
          group.translateZ(a.pos);
        }
        if(lato=='pav_retro' ){
          group.translateZ(a.pos);
        }
        if(lato=='pav_ds' ){
          group.translateX(-1*a.pos);
        }
        if( lato=='pav_sn'){
          group.translateX(a.pos);
        }
      } 

      anggroup.push(group);
    })
    
      

    return anggroup;
  }

  disegnaAngolariPavSof3(transY:number){
      let treVie=false;
      let pavsof='pav';
       if(transY!=0){ // pavimento
        pavsof='sof';
       }

    if(pavsof=='pav'){
      let startLeft=0;
      let tot=0;
   
      this.mS.objCella.objFronte.pannelli.forEach((p:any)=>{
        let lungAngolare=p.w;
        if(
          ((p.fittizio && !p.sopraporta) || (p.porta && p.porta.tipo1Porta!="SPORTELLI" &&
          (p.porta.tipologiaPorta=="SCORREVOLI" || p.porta.tipologiaPorta=="STANDARD")))
          && (this.mS.objCella.spessore !=13)
        ){
          if(tot>0){
            let wirefrAr:any=this.creaAngolare2(tot,'pav_fronte',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
              wirefr.rotateZ(Math.PI);
              wirefr.translateY(transY);
              wirefr.translateZ(startLeft); 
              this.group.add( wirefr );
            });
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }
        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
             treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr:any=this.creaAngolare2(tot,'pav_fronte',pavsof,treVie);
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateZ(Math.PI);
          wirefr.translateY(transY);
          wirefr.translateZ(startLeft); 
          this.group.add( wirefr );
        });
      }

      startLeft=0;
      tot=0;
      treVie=false;
      this.mS.objCella.objRetro.pannelli.forEach((p:any)=>{
        let lungAngolare=p.w;
        if(
          ((p.fittizio&& !p.sopraporta) || (p.porta && p.porta.tipo1Porta!="SPORTELLI" &&
          (p.porta.tipologiaPorta=="SCORREVOLI" || p.porta.tipologiaPorta=="STANDARD")))
          && (this.mS.objCella.spessore !=13)
        ){
          if(tot>0){
            let wirefrAr=this.creaAngolare2(tot,'pav_retro',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
              wirefr.rotateX(Math.PI);
              wirefr.translateX(this.mS.objCella.w);
              wirefr.translateY(transY);
              wirefr.translateZ(-tot-startLeft);
              this.group.add( wirefr );
            });
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }

        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
             treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr=this.creaAngolare2(tot,'pav_retro',pavsof,treVie);
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateX(Math.PI);
          wirefr.translateX(this.mS.objCella.w);
          wirefr.translateY(transY);
          wirefr.translateZ(-tot-startLeft);
          this.group.add( wirefr );
        });
      }

      startLeft=0;
      tot=0;
      treVie=false;

      this.mS.objCella.objLatSin.pannelli.forEach((p:any) => {
        let lungAngolare=p.w;
        if(
          ((p.fittizio && !p.sopraporta) || (p.porta && p.porta.tipo1Porta!="SPORTELLI" &&
          (p.porta.tipologiaPorta=="SCORREVOLI" || p.porta.tipologiaPorta=="STANDARD")))
          && (this.mS.objCella.spessore !=13)
        ){
          if(tot>0){
            let wirefrAr=this.creaAngolare2(tot,'pav_sn',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
              wirefr.rotateY(-Math.PI/2);
              wirefr.rotateZ(Math.PI);
              wirefr.translateZ(-tot-startLeft);
              wirefr.translateY(transY);
              this.group.add( wirefr );
            });
           startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }
        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
             treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr=this.creaAngolare2(tot,'pav_sn',pavsof,treVie);
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateY(-Math.PI/2);
          wirefr.rotateZ(Math.PI);
          wirefr.translateZ(-tot-startLeft);
          wirefr.translateY(transY);
          this.group.add( wirefr );
        });
      }
      tot=0;
      startLeft=0;
      treVie=false;
      this.mS.objCella.objLatDs.pannelli.forEach((p:any) => {
        let lungAngolare=p.w;
        if(
          ((p.fittizio && !p.sopraporta) || (p.porta && p.porta.tipo1Porta!="SPORTELLI" &&
          (p.porta.tipologiaPorta=="SCORREVOLI" || p.porta.tipologiaPorta=="STANDARD")))
          && (this.mS.objCella.spessore !=13)
        ){
          if(tot>0){
            let wirefrAr=this.creaAngolare2(tot,'pav_ds',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
              wirefr.rotateZ(Math.PI);
              wirefr.rotateY(Math.PI/2);
              wirefr.translateX(-this.mS.objCella.d);   
              wirefr.translateY(transY);
              wirefr.rotateZ(-Math.PI*1.5);
              wirefr.translateZ(-tot-startLeft);
              this.group.add( wirefr );
            });
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }
        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
             treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr=this.creaAngolare2(tot,'pav_ds',pavsof,treVie);
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateZ(Math.PI);
          wirefr.rotateY(Math.PI/2);
          wirefr.translateX(-this.mS.objCella.d);   
          wirefr.translateZ(-tot-startLeft);
          wirefr.translateY(transY);
          wirefr.rotateZ(-Math.PI*1.5);
          this.group.add( wirefr );
        })
      }
    }

    if(pavsof=='sof'){

      let startLeft=0;
      let tot=0;
      let totFittizio=0;
      treVie=false;
      this.mS.objCella.objFronte.pannelli.forEach((p:any)=>{
        let lungAngolare=p.w;
      
        if(p.fittizio && !p.sopraporta){
          if(tot>0){
            let wirefrAr:any=this.creaAngolare2(tot,'pav_fronte',pavsof,treVie);
            let gr = new THREE.Group();
            wirefrAr.forEach((wirefr:any)=>{
                wirefr.rotateZ(Math.PI);
                wirefr.translateZ(-startLeft-tot); 
                gr.add( wirefr );
              });
            gr.rotateX(Math.PI);
            gr.translateY(transY);
            this.group.add( gr );
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }
        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
             treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr:any=this.creaAngolare2(tot,'pav_fronte',pavsof,treVie);
        let gr = new THREE.Group();
        wirefrAr.forEach((wirefr:any)=>{
            wirefr.rotateZ(Math.PI);
            wirefr.translateZ(-startLeft-tot); 
            gr.add( wirefr );
          });
        gr.rotateX(Math.PI);
        gr.translateY(transY);
        this.group.add( gr );
      }

      startLeft=0;
      tot=0;
      treVie=false;
      this.mS.objCella.objRetro.pannelli.forEach((p:any)=>{
        let lungAngolare=p.w;
    
        if(p.fittizio && !p.sopraporta){
          if(tot>0){
            let wirefrAr=this.creaAngolare2(tot,'pav_retro',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
            //  wirefr.rotateX(-Math.PI);
              wirefr.translateX(this.mS.objCella.w);
              wirefr.translateY(-transY);
              wirefr.translateZ(startLeft);
              this.group.add( wirefr );
            });
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }
        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
             treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr=this.creaAngolare2(tot,'pav_retro',pavsof,treVie);
          wirefrAr.forEach((wirefr:any)=>{
        //  wirefr.rotateX(-Math.PI);
          wirefr.translateX(this.mS.objCella.w);
          wirefr.translateY(-transY);
           wirefr.translateZ(startLeft);
          this.group.add( wirefr );
        });
      }

      startLeft=0;
      totFittizio=0;
      tot=0;
      treVie=false;
      this.mS.objCella.objLatSin.pannelli.forEach((p:any) => {
        let lungAngolare=p.w;
     
        if(p.fittizio && !p.sopraporta){
          if(tot>0){
            let wirefrAr=this.creaAngolare2(tot,'pav_sn',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
              wirefr.rotateY(Math.PI/2);
              wirefr.translateY(-transY);
              wirefr.translateZ(startLeft);
              this.group.add( wirefr );
            });
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
             startLeft+=lungAngolare;
          }
        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
            treVie=p.treVie;
          }
        }
      });
      if(tot>0){
        let wirefrAr=this.creaAngolare2(tot,'pav_sn',pavsof,treVie);
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateY(Math.PI/2);
          wirefr.translateY(-transY);
          wirefr.translateZ(startLeft);
          this.group.add( wirefr );
        });
      }
      tot=0;
      startLeft=0;
      treVie=false;
      this.mS.objCella.objLatDs.pannelli.forEach((p:any) => {
        let lungAngolare=p.w;
       
        if(p.fittizio  && !p.sopraporta){
          if(tot>0){
            let wirefrAr=this.creaAngolare2(tot,'pav_ds',pavsof,treVie);
            wirefrAr.forEach((wirefr:any)=>{
              wirefr.rotateZ(Math.PI);
              wirefr.translateY(transY);
              wirefr.rotateX(Math.PI);
              wirefr.translateZ(-this.mS.objCella.d);
              wirefr.rotateY(Math.PI/2);
              wirefr.translateZ(-tot-startLeft);
            this.group.add( wirefr );
            });
            startLeft+=tot+lungAngolare;
            tot=0;
          } else {
            startLeft+=lungAngolare;
            
          }

        } else {
          if(!p.sopraporta){
            tot+=lungAngolare;
            treVie=p.treVie;
          }

        }
      });
      if(tot>0){
        let wirefrAr=this.creaAngolare2(tot,'pav_ds',pavsof,treVie);
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateZ(Math.PI);
          wirefr.translateY(transY);
          wirefr.rotateX(Math.PI);
          wirefr.translateZ(-this.mS.objCella.d);
          wirefr.rotateY(Math.PI/2);
          wirefr.translateZ(-tot-startLeft);
         this.group.add( wirefr );
        });
      }
   
    }
  }
  
  disegnaAngolariPavSof2(transY:number){
    if(transY==0){ // pavimento

      // pav fronte
      let startLeft=0;
      let largPorta=0;
      this.mS.cellaDati.elencoPorte.filter((x:any)=>(!x.divisorioCollegatoId || x.divisorioCollegatoId=='') && x.lato_porta=='lato_fronte').forEach((p:any)=>{
        if(p.distSnPorta>0 && p.distSnPorta-startLeft>0){
          let wirefrAr:any=this.creaAngolare2(p.distSnPorta-startLeft,'pav_fronte','pav');
          wirefrAr.forEach((wirefr:any)=>{
            wirefr.rotateZ(Math.PI);
            wirefr.translateY(transY);
            wirefr.translateZ(startLeft);
            this.group.add( wirefr );
          });
        }
        largPorta=p.larghporta;
        startLeft=p.distSnPorta+largPorta;
       
      });
    
      if(startLeft<this.mS.objCella.d){
        let wirefrAr=this.creaAngolare2(this.mS.objCella.d-startLeft,'pav_fronte','pav');
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateZ(Math.PI);
          wirefr.translateY(transY);
          wirefr.translateZ(startLeft);
          this.group.add( wirefr );
        });
      }

      // pav lato ds
      startLeft=0;
      largPorta=0;
      this.mS.cellaDati.elencoPorte.filter((x:any)=>(!x.divisorioCollegatoId || x.divisorioCollegatoId=='') && x.lato_porta=='lato_ds').forEach((p:any)=>{
        if(p.distSnPorta>0 && p.distSnPorta-startLeft>0){
          let wirefrAr=this.creaAngolare2(p.distSnPorta-startLeft,'pav_ds','pav');
          wirefrAr.forEach((wirefr:any)=>{
            wirefr.rotateZ(Math.PI);
            wirefr.rotateY(Math.PI/2);
            wirefr.translateX(-this.mS.objCella.d);   
            wirefr.translateZ(-p.distSnPorta);
            wirefr.translateY(transY);
            wirefr.rotateZ(-Math.PI*1.5);
            this.group.add( wirefr );
          })
        }
        largPorta=p.larghporta;
        startLeft=p.distSnPorta+largPorta;
      });
      if(startLeft<this.mS.objCella.w){
       let wirefrAr=this.creaAngolare2(this.mS.objCella.w-startLeft,'pav_ds','pav');
       wirefrAr.forEach((wirefr:any)=>{
        wirefr.rotateZ(Math.PI);
        wirefr.rotateY(Math.PI/2);
        wirefr.translateX(-this.mS.objCella.d);    
        wirefr.translateZ(-this.mS.objCella.w);        
        wirefr.translateY(transY);        
        wirefr.rotateZ(-Math.PI*1.5);
        this.group.add( wirefr );
       });
      }

      // pav retro      
      startLeft=0;
      largPorta=0;
      this.mS.cellaDati.elencoPorte.filter((x:any)=>(!x.divisorioCollegatoId || x.divisorioCollegatoId=='') && x.lato_porta=='lato_retro').forEach((p:any)=>{
        if(p.distSnPorta>0 && p.distSnPorta-startLeft>0){
          let wirefrAr=this.creaAngolare2(p.distSnPorta-startLeft,'pav_retro','pav');
          wirefrAr.forEach((wirefr:any)=>{
            wirefr.rotateX(Math.PI);
            wirefr.translateX(this.mS.objCella.w);
            wirefr.translateY(transY);
            wirefr.translateZ(-1*this.mS.objCella.d+startLeft);
            this.group.add( wirefr );
          });
        }
        largPorta=p.larghporta;
        startLeft=p.distSnPorta+largPorta;
       
      });
      if(startLeft<this.mS.objCella.w){  
        let wirefrAr=this.creaAngolare2(this.mS.objCella.d-startLeft,'pav_retro','pav');
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateX(Math.PI);
          wirefr.translateX(this.mS.objCella.w);
          wirefr.translateY(transY);
          wirefr.translateZ(-1*this.mS.objCella.d+startLeft);
          this.group.add( wirefr );
        });
      }

      // pav lato sn
      startLeft=0;
      largPorta=0;
      this.mS.cellaDati.elencoPorte.filter((x:any)=>(!x.divisorioCollegatoId || x.divisorioCollegatoId=='') && x.lato_porta=='lato_sn').forEach((p:any)=>{
        if(p.distSnPorta>0 && p.distSnPorta-startLeft>0){
          let wirefrAr=this.creaAngolare2(p.distSnPorta-startLeft,'pav_sn','pav');
          wirefrAr.forEach((wirefr:any)=>{
            wirefr.rotateY(-Math.PI/2);
            wirefr.rotateZ(Math.PI);
            wirefr.translateZ(-p.distSnPorta);
            wirefr.translateY(transY);
            this.group.add( wirefr );
          })
        }
        largPorta=p.larghporta;
        startLeft=p.distSnPorta+largPorta;
       
      });
      if(startLeft<this.mS.objCella.w){
        let wirefrAr=this.creaAngolare2(this.mS.objCella.w-startLeft,'pav_sn','pav');
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateY(-Math.PI/2);
          wirefr.rotateZ(Math.PI);
          wirefr.translateZ(-this.mS.objCella.w);
          wirefr.translateY(transY);
          this.group.add( wirefr );
        });
          
       
      }

    } else {
      // SOFFITTO

      // pav fronte
      let wirefrAr=this.creaAngolare2(this.mS.objCella.d,'pav_fronte','sof');
       let gr = new THREE.Group();
        wirefrAr.forEach((wirefr:any)=>{
          wirefr.rotateZ(Math.PI);
          wirefr.translateZ(-this.mS.objCella.d); 
          gr.add( wirefr );
        });
       gr.rotateX(Math.PI);
       gr.translateY(transY);
       this.group.add( gr );

        // pav lato ds
      wirefrAr=this.creaAngolare2(this.mS.objCella.w,'pav_ds','sof');
      wirefrAr.forEach((wirefr:any)=>{
        wirefr.rotateZ(Math.PI);
        wirefr.translateY(transY);
        wirefr.rotateX(Math.PI);
        wirefr.translateZ(-this.mS.objCella.d);
        wirefr.rotateY(Math.PI/2);
        wirefr.translateZ(-this.mS.objCella.w);
        this.group.add( wirefr );
      });
      // pav retro
      wirefrAr=this.creaAngolare2(this.mS.objCella.d,'pav_retro','sof');
        wirefrAr.forEach((wirefr:any)=>{
        //  wirefr.rotateX(-Math.PI);
          wirefr.translateX(this.mS.objCella.w);
          wirefr.translateY(-transY);
          this.group.add( wirefr );
        });
     
    
      // pav lato sn
      wirefrAr=this.creaAngolare2(this.mS.objCella.w,'pav_sn','sof');
      wirefrAr.forEach((wirefr:any)=>{
        wirefr.rotateY(Math.PI/2);
        wirefr.translateY(-transY);
        this.group.add( wirefr );
      });
    }
   
  }

  creaAngolare(lunghezzeAngolare:number){
    let shape = new THREE.Shape();
    shape.absarc( 0, 0, this.raggioSmussoAngolare, 0.5* Math.PI,0,  true );
    shape.lineTo(this.latoAngolare,0);
    shape.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
    shape.lineTo(this.latoAngolare,0);
    shape.lineTo(this.latoAngolare,this.latoAngolare-this.raggioSmussoAngolare);
    shape.absarc( this.latoAngolare-this.raggioSmussoAngolare, this.latoAngolare-this.raggioSmussoAngolare, this.raggioSmussoAngolare, 0,0.5* Math.PI,  false );
    shape.lineTo(0,this.latoAngolare);
    shape.lineTo(this.latoAngolare-this.raggioSmussoAngolare,this.latoAngolare);
    shape.lineTo(0,this.latoAngolare);
    let geoShape = new THREE.ShapeGeometry( shape );

    let shape1=shape.clone();
    let geoShape1 = new THREE.ShapeGeometry( shape1 );
    geoShape1.translate(0,0,lunghezzeAngolare);

    let shapeQ = new THREE.Shape();
    shapeQ.lineTo(0,lunghezzeAngolare);
    shapeQ.lineTo(this.latoAngolare-this.raggioSmussoAngolare,lunghezzeAngolare);
    shapeQ.lineTo(this.latoAngolare-this.raggioSmussoAngolare,0);
    let geoShapeQ = new THREE.ShapeGeometry( shape1 );
    geoShapeQ.translate(0,this.latoAngolare,0);


    var mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
    var geox = new THREE.EdgesGeometry( geoShape,30 ); // or WireframeGeometry( geometry )
    let  wirex= new THREE.LineSegments( geox, mat );
    wirex.updateMatrix();

    
    var extrudedGeometry = new THREE.ExtrudeGeometry(shape, {depth: lunghezzeAngolare,steps:1, bevelEnabled: true});
    return extrudedGeometry;
  }

  addGeometryToScene(extrudedGeometry:THREE.ExtrudeGeometry,coloro:any=0xff0000){

    var extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: coloro}));
    this.group.add( extrudedMesh );
    var geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
    var mat11 = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
    let  wirefr= new THREE.LineSegments( geo211w, mat11 );
    wirefr.updateMatrix();
    this.group.add( wirefr );

  }

  /** Solo spigoli (niente riempimento), es. trave a soffitto. */
  addWireframeToScene(extrudedGeometry:THREE.ExtrudeGeometry,coloro:any=0xff0000){
    var geo211w = new THREE.EdgesGeometry( extrudedGeometry, 30 );
    var mat11 = new THREE.LineBasicMaterial( { color: coloro, linewidth: 1 } );
    let wirefr = new THREE.LineSegments( geo211w, mat11 );
    wirefr.updateMatrix();
    this.group.add( wirefr );
  }

  /** True se sul lato, all'inizio o in fondo, c'è un pannello compensatorio 27/31
   *  (eventualmente dopo/prima del fittizio sp+3 del blocco 40). */
  private hasCompensatorioAllAngolo(pannelli: any[], atStart: boolean): boolean {
    const list = (pannelli || []).filter((p: any) => p && !p.sopraporta);
    if (!list.length) {
      return false;
    }
    const seq = atStart ? list : [...list].reverse();
    for (const p of seq) {
      const w = Number(p.w) || 0;
      if (w === 27 || w === 31) {
        return true;
      }
      // fittizio 9/13 (o altro) prima del compensatorio: continua
      if (p.fittizio) {
        continue;
      }
      // primo pannello "reale" non è compensatorio
      return false;
    }
    return false;
  }

  /** True se `posAng` è start (inizio pannelli) del lato indicato. */
  private angoloEStartDelLato(posAng: string, lato: string): boolean {
    if (lato === 'lato_fronte' || lato === 'lato_sn') {
      return posAng === '0';
    }
    if (lato === 'lato_retro') {
      return posAng === 'w';
    }
    if (lato === 'lato_ds') {
      return posAng === 'd';
    }
    return false;
  }

  /** True se `posAng` è end (fine pannelli) del lato indicato. */
  private angoloEEndDelLato(posAng: string, lato: string): boolean {
    if (lato === 'lato_fronte') {
      return posAng === 'd';
    }
    if (lato === 'lato_retro' || lato === 'lato_ds') {
      return posAng === 'wd';
    }
    if (lato === 'lato_sn') {
      return posAng === 'w';
    }
    return false;
  }

  /**
   * Angolo 270° della cella corta (unite/divisorio): lì Compenso270 mette un 27/31
   * su questa cella e l'altro sulla cella lunga al confine fittizio.
   */
  private isAngolo270CellaCorta(posAng: string): boolean {
    const cella = this.mS.cellaDati;
    const config = this.configurazioneCelle;
    if (!cella || !config) {
      return false;
    }
    const covers = this.mS.getUniteCoversComeBordi(config);
    const { lato1, lato2 } = this.mS.getLatiAngolo(posAng);
    for (const lato of [lato1, lato2]) {
      if (!lato) {
        continue;
      }
      const ang = this.mS.getAngoli270DaCellaCorta(lato, cella, covers, config);
      if (this.angoloEStartDelLato(posAng, lato) && ang.start) {
        return true;
      }
      if (this.angoloEEndDelLato(posAng, lato) && ang.end) {
        return true;
      }
    }
    return false;
  }

  /**
   * Cappuccio all'intersezione di due compensatori 27/31 (angoli 270° / blocco 40).
   * Spigoli: '0' fronte+sn, 'w' sn+retro, 'wd' retro+ds, 'd' ds+fronte.
   *
   * Nella L (cella corta): un compensatorio è sul lato libero di questa cella,
   * l'altro sulla lunga allo step — non entrambi sui due lati locali.
   */
  isCappuccioIntersezioneCompensatori(posAng: string): boolean {
    const oc = this.mS.objCella;
    if (!oc) {
      return false;
    }
    // per ogni lato: true = inizio array pannelli, false = fine
    let checks: { pannelli: any[]; atStart: boolean }[] = [];
    switch (posAng) {
      case '0': // fronte start (sn) + sn start (fronte)
        checks = [
          { pannelli: oc.objFronte?.pannelli, atStart: true },
          { pannelli: oc.objLatSin?.pannelli, atStart: true },
        ];
        break;
      case 'w': // sn end (retro) + retro start (sn)
        checks = [
          { pannelli: oc.objLatSin?.pannelli, atStart: false },
          { pannelli: oc.objRetro?.pannelli, atStart: true },
        ];
        break;
      case 'wd': // retro end (ds) + ds end (retro)
        checks = [
          { pannelli: oc.objRetro?.pannelli, atStart: false },
          { pannelli: oc.objLatDs?.pannelli, atStart: false },
        ];
        break;
      case 'd': // ds start (fronte) + fronte end (ds)
        checks = [
          { pannelli: oc.objLatDs?.pannelli, atStart: true },
          { pannelli: oc.objFronte?.pannelli, atStart: false },
        ];
        break;
      default:
        return false;
    }
    const localComp = checks.map((c) =>
      this.hasCompensatorioAllAngolo(c.pannelli, c.atStart),
    );
    // entrambi i lati locali (stessa cella)
    if (localComp.every(Boolean)) {
      return true;
    }
    // cella corta a 270°: un 27/31 locale + l'altro sulla cella lunga
    if (localComp.some(Boolean) && this.isAngolo270CellaCorta(posAng)) {
      return true;
    }
    return false;
  }

  addCodeCappuccio(lato='', treVie=false){
    const cappNormale='000a00';
    const capp3Vie='000b03';
    const cappA1='000a10';

    let codcal='K7';
    if(this.mS.cellaDati.finitura!='STANDARD'){
      codcal='K8';
    }
    let tipocapp = cappNormale;
    if (this.isCappuccioIntersezioneCompensatori(lato)) {
      tipocapp = cappA1;
    } else if (treVie) {
      tipocapp = capp3Vie;
    }
    this.mS.objCella.cappucci.push({
        name:codcal+this.mS.objCella.spessore.toString().padStart(2,"0")+tipocapp
    });

  }

  
  tipoAngolo(posAng:string){
    // Spigoli come in disegnaAngolariVert2:
    // '0'  = fronte + sn
    // 'w'  = sn + retro
    // 'wd' = retro + ds
    // 'd'  = ds + fronte
    const { lato1, lato2 } = this.mS.getLatiAngolo(posAng);

     /*

    if(this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.tipoCollegamento!='unite' 
    && x.latocollegato==lato1 
    && x.latocombinato).length>0){
      return '';
    }
      */
    
    // tre vie: T del divisorio sulla cella che lo possiede (di solito la più stretta)
    if (this.mS.isAngoloTreVieDivisorio(posAng, this.mS.cellaDati, this.configurazioneCelle)) {
      return 'collegateDivisorio';
    }
    // divisorio a tutto lato tra celle uguali → stesso tipo angolo
    if (
      this.mS.isAngoloDivisorioATuttoLatoUguale(
        posAng,
        this.mS.cellaDati,
        this.configurazioneCelle,
      )
    ) {
      return 'collegateDivisorio';
    }
    
    let cellecombinateSn=this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato
    && (x.tipoCollegamento=='combinate' && x.latocollegato==lato2 ) );

    let cellecombinateDs=this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo  && !x.latocombinato
    && (x.tipoCollegamento=='combinate' &&  x.latocollegato==lato1) );

    if(cellecombinateDs.length>0){
      return 'combinateDs';
    }
    if(cellecombinateSn.length>0){
      return 'combinateSn';
    }
    return 'normale';

  }
  
  disegnaCappucci(angoloCappuccio:string, treVie=false){
    let cappuccio=this.creaCappuccio(treVie);
    // 0,0
    if(angoloCappuccio=='0'){
      let cappuccio0=cappuccio.clone();
      cappuccio0.rotateZ(-1*Math.PI);
      cappuccio0.rotateY(Math.PI);
      if(this.mS.cellaDati.pavimenti){
          this.group.add( cappuccio0 );
          this.addCodeCappuccio('0', treVie);
      }
      let cappuccio1h=cappuccio.clone();
      cappuccio1h.translateY(this.mS.objCella.h);
      cappuccio1h.rotateY(-Math.PI/2);
      this.group.add( cappuccio1h );
      this.addCodeCappuccio('0', treVie);
        
    }

    // w,0

     if(angoloCappuccio=='w'){
      let cappuccio1=cappuccio.clone();
      cappuccio1.translateX(this.mS.objCella.w);
      cappuccio1.rotateZ(Math.PI);
      cappuccio1.rotateY(-Math.PI/2);
      if(this.mS.cellaDati.pavimenti){
        this.group.add( cappuccio1 );
        this.addCodeCappuccio('w', treVie);
      }
      let cappuccio2h=cappuccio.clone();
      cappuccio2h.translateY(this.mS.objCella.h);
      cappuccio2h.translateX(this.mS.objCella.w);
      cappuccio2h.rotateY(-Math.PI);
      this.group.add( cappuccio2h );
      this.addCodeCappuccio('w', treVie);
    }
 
    // w,d
     if(angoloCappuccio=='wd'){
      let cappuccio2=cappuccio.clone();
      cappuccio2.translateX(this.mS.objCella.w);
      cappuccio2.translateZ(this.mS.objCella.d);
      cappuccio2.rotateZ(-Math.PI);
      if(this.mS.cellaDati.pavimenti){
          this.group.add( cappuccio2 );
          this.addCodeCappuccio('wd', treVie);
      }
      let cappuccio3h=cappuccio.clone();
      cappuccio3h.translateY(this.mS.objCella.h);
      cappuccio3h.translateX(this.mS.objCella.w);
      cappuccio3h.translateZ(this.mS.objCella.d);
      cappuccio3h.rotateY(Math.PI/2);
      this.group.add( cappuccio3h );
      this.addCodeCappuccio('wd', treVie);
    }

    // 0,d
     if(angoloCappuccio=='d'){
      let cappuccio3=cappuccio.clone();
      cappuccio3.translateZ(this.mS.objCella.d);
      cappuccio3.rotateZ(-Math.PI);
      cappuccio3.rotateY(Math.PI/2);
      if(this.mS.cellaDati.pavimenti){
        this.group.add( cappuccio3 );
        this.addCodeCappuccio('d', treVie);
      }
      let cappuccio4h=cappuccio.clone();
      cappuccio4h.translateY(this.mS.objCella.h);
      cappuccio4h.translateZ(this.mS.objCella.d);
      this.group.add( cappuccio4h );
      this.addCodeCappuccio('d', treVie);
    }
  }


  disegnaAngolariVert2(){
    let uniteLatoFronte=false;
    let uniteLatoRetro=false;
    let uniteLatoSn=false;
    let uniteLatoDs=false;
    // asta angolare su unite/270°: spessore + 3 per lato (allinea all'inizio pannelli)
    const offAngUnite = (this.mS.objCella.spessore || 0) + 3;

    if(this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato && x.tipoCollegamento=='unite' && x.latocollegato=='lato_retro').length>0){
      uniteLatoRetro=true;
    }
    
    if(this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato && x.tipoCollegamento=='unite' && x.latocollegato=='lato_fronte').length>0){
      uniteLatoFronte=true;
    }

    if(this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato && x.tipoCollegamento=='unite' && x.latocollegato=='lato_ds').length>0){
      uniteLatoDs=true;
    }
    if(this.mS.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato && x.tipoCollegamento=='unite' && x.latocollegato=='lato_sn').length>0){
      uniteLatoSn=true;
    }

   // incrocio lato_fronte lato_sn 
    let lungTotPan=0;
    let saltaAng=false;
    let last=0;
  

       
    
    if(this.mS.disegnaAngolo('0',this.configurazioneCelle)){
      const treVie0=this.tipoAngolo('0')=='collegateDivisorio';
      let wirefrAr1=this.creaAngolare2(this.mS.objCella.h,'0','',treVie0);
      let gr= new THREE.Group();
      wirefrAr1.forEach((wirefr:any)=>{   
        gr.add( wirefr );
      });  
      gr.rotateX(-Math.PI/2);
      if(uniteLatoSn){
        gr.translateX(-offAngUnite);
        gr.translateY(-offAngUnite);
      } else {
        if(uniteLatoFronte){
          gr.rotateZ(Math.PI);
          gr.translateX(-offAngUnite);
          gr.translateY(-offAngUnite);
        } else {
          gr.rotateZ(Math.PI/2);
        }
      }
  
     this.group.add( gr );
     this.disegnaCappucci('0', treVie0);
    }
   
   // incrocio lato_sn lato_retro
    saltaAng=false;
    if(this.mS.objCella.objRetro.pannelli.length==0 || this.mS.objCella.objRetro.pannelli[0].fittizio){
      saltaAng=true;
    }
    
    if(this.mS.objCella.objLatSin?.fittizio && this.mS.objCella.objRetro?.fittizio && this.mS.objCella.objLatSin.pannelli.length==0 && this.mS.objCella.objRetro.pannelli.length==0){
      saltaAng=false;
    }
    if(this.mS.disegnaAngolo('w',this.configurazioneCelle)){
      const treVieW=this.tipoAngolo('w')=='collegateDivisorio';
      let wirefrAr2=this.creaAngolare2(this.mS.objCella.h,'w','',treVieW);
      let gr1= new THREE.Group();
      wirefrAr2.forEach((wirefr:any)=>{   
        gr1.add( wirefr );
      });  
      gr1.rotateX(-Math.PI/2);
      gr1.translateX(this.mS.objCella.w);

      if(uniteLatoSn){
        gr1.rotateZ(Math.PI/2);
        gr1.translateX(-offAngUnite);
        gr1.translateY(-offAngUnite);
        
      } else {
        if(uniteLatoRetro){
          gr1.rotateZ(-Math.PI);
          gr1.translateX(offAngUnite);
          gr1.translateY(-offAngUnite);
          gr1.rotateZ(Math.PI/2);
        } else {
        
        }
      }
      this.group.add( gr1 );
      this.disegnaCappucci('w', treVieW);
    }

    

// incrocio  lato_retro lato_destro
    lungTotPan=0;
    saltaAng=false;

    last=this.mS.objCella.objLatDs.pannelli.length-1;
  
     if(this.mS.objCella.objLatDs.pannelli.length==0 || this.mS.objCella.objLatDs.pannelli[last].fittizio){
      saltaAng=true;
    }
    if(this.mS.objCella.objLatDs?.fittizio && this.mS.objCella.objRetro?.fittizio &&  this.mS.objCella.objLatDs.pannelli.length==0 && this.mS.objCella.objRetro.pannelli.length==0){
      saltaAng=false;
    }
    if(this.mS.disegnaAngolo('wd',this.configurazioneCelle)){
      const treVieWd=this.tipoAngolo('wd')=='collegateDivisorio';
      let wirefrAr3=this.creaAngolare2(this.mS.objCella.h,'wd','',treVieWd);
      let gr3= new THREE.Group();
      wirefrAr3.forEach((wirefr:any)=>{   
        gr3.add( wirefr );
      });  
      gr3.rotateX(-Math.PI/2);
      gr3.translateX(this.mS.objCella.w);
      gr3.translateY(-this.mS.objCella.d);
      if(uniteLatoRetro){
        gr3.translateX(-offAngUnite);
        gr3.translateY(-offAngUnite);
      } else {
        if(uniteLatoDs){
          gr3.rotateZ(-Math.PI/2);
          gr3.translateX(-offAngUnite);
          gr3.translateY(-offAngUnite);
        } else {
          gr3.rotateZ(-Math.PI/2);
        }
      }
    
     this.group.add( gr3 );
     this.disegnaCappucci('wd', treVieWd);

    }

    
// incrocio   lato_destro lato_fronte
    lungTotPan=0;
    saltaAng=false;
  
    
    if(this.mS.objCella.objLatDs.pannelli.length==0 || this.mS.objCella.objLatDs.pannelli[last].fittizio){
      saltaAng=true;
    }
    if(this.mS.objCella.objLatDs?.fittizio && this.mS.objCella.objFronte?.fittizio &&  this.mS.objCella.objLatDs.pannelli.length==0 && this.mS.objCella.objFronte.pannelli.length==0){
      saltaAng=false;
    }
    
  if(this.mS.disegnaAngolo('d',this.configurazioneCelle)){
    const treVieD=this.tipoAngolo('d')=='collegateDivisorio';
    let wirefrAr4=this.creaAngolare2(this.mS.objCella.h,'d','',treVieD);
    let gr4= new THREE.Group();
    wirefrAr4.forEach((wirefr:any)=>{   
      gr4.add( wirefr );
    });  
    gr4.rotateX(-Math.PI/2);
    gr4.translateY(-this.mS.objCella.d);

    if(uniteLatoDs){
        gr4.rotateZ(Math.PI/2);
        gr4.translateX(-offAngUnite);
        gr4.translateY(-offAngUnite);
    } else {
      if(uniteLatoFronte){
        gr4.rotateZ(Math.PI/2);
        gr4.translateX(-offAngUnite);
        gr4.translateY(-offAngUnite);
      } else {
          gr4.rotateZ(Math.PI);
              
      }
    }
    
    this.group.add( gr4 );
    this.disegnaCappucci('d', treVieD);

  }


  }

  disegnaAngolariVert(){
    // 0,0
    let extrudedGeometry=this.creaAngolare(this.mS.objCella.h);
    extrudedGeometry.rotateZ(Math.PI);
    extrudedGeometry.rotateX(Math.PI/2);
    extrudedGeometry.translate(0,this.mS.objCella.h,0);
    this.addGeometryToScene(extrudedGeometry);

    
    // w,0
    extrudedGeometry=this.creaAngolare(this.mS.objCella.h);
    extrudedGeometry.rotateX(Math.PI/2);
    extrudedGeometry.rotateY(Math.PI/2);
    extrudedGeometry.translate(this.mS.objCella.w,this.mS.objCella.h,0);
    this.addGeometryToScene(extrudedGeometry);
    // w,d
    extrudedGeometry=this.creaAngolare(this.mS.objCella.h);
    extrudedGeometry.rotateX(Math.PI/2);
    extrudedGeometry.translate(this.mS.objCella.w,this.mS.objCella.h,this.mS.objCella.d);
    this.addGeometryToScene(extrudedGeometry);
    // 0,d
    extrudedGeometry=this.creaAngolare(this.mS.objCella.h);
    extrudedGeometry.rotateX(Math.PI/2);
    extrudedGeometry.rotateY(-Math.PI/2);
    extrudedGeometry.translate(0,this.mS.objCella.h,this.mS.objCella.d);
    this.addGeometryToScene(extrudedGeometry);
  }

  disegnaAngolariPavSof(transY:number){
    // pav fronte
    let extrudedGeometry=this.creaAngolare(this.mS.objCella.d);
    extrudedGeometry.rotateZ(Math.PI);
    if(transY>0){
        extrudedGeometry.translate(0,transY,0);
    }
    this.addGeometryToScene(extrudedGeometry);
    // pav lato ds
    extrudedGeometry=this.creaAngolare(this.mS.objCella.w);
    extrudedGeometry.rotateZ(Math.PI);
    extrudedGeometry.rotateY(Math.PI/2);
    extrudedGeometry.translate(0,transY,this.mS.objCella.d);
    this.addGeometryToScene(extrudedGeometry);
     // pav retro
    extrudedGeometry=this.creaAngolare(this.mS.objCella.d);
    extrudedGeometry.rotateX(Math.PI);
    extrudedGeometry.translate(this.mS.objCella.w,transY,this.mS.objCella.d);
    this.addGeometryToScene(extrudedGeometry);
    // pav lato sn
    extrudedGeometry=this.creaAngolare(this.mS.objCella.w);
    extrudedGeometry.rotateY(Math.PI/2);
    extrudedGeometry.rotateZ(Math.PI);
    extrudedGeometry.translate(this.mS.objCella.w,transY,0);
    this.addGeometryToScene(extrudedGeometry);
    
  }
  
  drawPorta(offsetX:number,offsetY:number,offsetZ:number,panel:any,side:string){
    
      const color=this.mS.colorPortaHex;
     let p={
      w:panel.w,
      h:panel.h,
      wstipite:10,
      spessorebattente:panel.d,
      ymaniglia:100,
      hmaniglia:10,
      wmaniglia:3,
      hcerniera:7,
      wcerniera:3,
      xguida:-3, // rispetto all'angolo porta
      yguida:-3, // rispettoa all'altporta
      wguida:150,
      hguida:4

    }


    const group = new THREE.Group();

    
    let glass:any=this.fillPanel(p.w-p.wstipite*2,panel.h,  p.spessorebattente,color);
    glass.translateY( panel.h/2);
    glass.translateZ( p.spessorebattente/2);
    glass.translateX( (p.w-p.wstipite*2)/2+p.wstipite);
    group.add( glass );

    var shape1 = new THREE.Shape();
    shape1.moveTo(0, 0 );
    shape1.lineTo(p.wstipite,0);
    shape1.lineTo(p.wstipite,p.h-p.wstipite);
    shape1.lineTo(p.w-p.wstipite,p.h-p.wstipite);
    shape1.lineTo(p.w-p.wstipite,0);
    shape1.lineTo(p.w,0);
    shape1.lineTo(p.w,p.h);
    shape1.lineTo(0,p.h);
    shape1.lineTo(0,0);
    var extrudedGeometry = new THREE.ExtrudeGeometry(shape1, {depth: p.spessorebattente,steps:1, bevelEnabled: true});
    var extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: color}));
    var geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
    var mat11 = new THREE.LineBasicMaterial( { color: color, linewidth: 1 } );
    let wirefr= new THREE.LineSegments( geo211w, mat11 );
    group.add( wirefr );
    
    var shape2 = new THREE.Shape();
    shape2.moveTo( p.wstipite, 0 );
    shape2.lineTo(p.wstipite,p.h-p.wstipite);
    shape2.lineTo(p.w-p.wstipite,p.h-p.wstipite);
    shape2.lineTo(p.w-p.wstipite,0);
    shape2.moveTo( p.wstipite, 0 );
    extrudedGeometry = new THREE.ExtrudeGeometry(shape2, {depth: p.spessorebattente,steps:1, bevelEnabled: true});
    extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: color}));
    geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
    mat11 = new THREE.LineBasicMaterial( { color: color, linewidth: 1 } );
    wirefr= new THREE.LineSegments( geo211w, mat11 );
    wirefr.translateZ(p.spessorebattente);
    wirefr.updateMatrix();
    group.add( wirefr );

    // maniglia
    var shape3 = new THREE.Shape();
    shape3.moveTo( p.w-p.wstipite, p.ymaniglia );
    shape3.lineTo(p.w-p.wstipite, p.ymaniglia+p.hmaniglia);
    shape3.lineTo(p.w-p.wstipite+p.wmaniglia, p.ymaniglia+p.hmaniglia);
    shape3.lineTo(p.w-p.wstipite+p.wmaniglia, p.ymaniglia);
    shape3.lineTo(p.w-p.wstipite, p.ymaniglia);
    extrudedGeometry = new THREE.ExtrudeGeometry(shape3, {depth: p.spessorebattente,steps:1, bevelEnabled: true});
    extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: color}));
    geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
    mat11 = new THREE.LineBasicMaterial( { color: color, linewidth: 1 } );
    wirefr= new THREE.LineSegments( geo211w, mat11 );
    wirefr.translateZ(p.spessorebattente);
    wirefr.updateMatrix();
    group.add( wirefr );
  
    

    if(!panel.porta.scorrevole){
      //cerniera
      var shape4 = new THREE.Shape();
      shape4.moveTo(p.wstipite, p.h-p.wstipite-p.hcerniera );
      shape4.lineTo(p.wstipite, p.h-p.wstipite );
      shape4.lineTo(p.wstipite-p.wcerniera, p.h-p.wstipite );
      shape4.lineTo(p.wstipite-p.wcerniera, p.h-p.wstipite-p.hcerniera/2 );
      shape4.lineTo(p.wstipite-p.wcerniera/2, p.h-p.wstipite-p.hcerniera );
      shape4.lineTo(p.wstipite, p.h-p.wstipite-p.hcerniera );
      extrudedGeometry = new THREE.ExtrudeGeometry(shape4, {depth: p.spessorebattente,steps:1, bevelEnabled: true});
      extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: color}));
      geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
      mat11 = new THREE.LineBasicMaterial( { color: color, linewidth: 1 } );
      wirefr= new THREE.LineSegments( geo211w, mat11 );
      wirefr.translateZ(p.spessorebattente);
      wirefr.updateMatrix();
      group.add( wirefr );

      //cerniera
      let wirefr2=wirefr.clone();
      wirefr2.translateZ(p.spessorebattente);
      wirefr2.translateX(p.w);
      wirefr2.rotateY(Math.PI);
      
      wirefr2.updateMatrix();
      group.add( wirefr2 );

    }
    if(panel.porta.scorrevole){
      // guida
      if(panel.porta.versoAperturaPorta==1){
          p.wguida=80;
      } else {
          p.wguida=-80;
      }
    

      var shape5 = new THREE.Shape();
      shape5.moveTo(p.w+p.xguida,p.h+p.yguida);
      shape5.lineTo(p.w+p.xguida,p.h+p.yguida-p.hguida);
      shape5.lineTo(p.w+p.xguida+p.wguida,p.h+p.yguida-p.hguida);
      shape5.lineTo(p.w+p.xguida+p.wguida,p.h+p.yguida);
      shape5.lineTo(p.w+p.xguida,p.h+p.yguida);
   
      extrudedGeometry = new THREE.ExtrudeGeometry(shape5, {depth: p.spessorebattente,steps:1, bevelEnabled: true});
      extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: color}));
      geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
      mat11 = new THREE.LineBasicMaterial( { color: color, linewidth: 1 } );
      wirefr= new THREE.LineSegments( geo211w, mat11 );
      if(panel.porta.versoAperturaPorta==2){
        wirefr.translateX( p.wguida*1.2);
      } else {
        wirefr.translateX( -10);
      }
      group.add( wirefr );
    }
    if(!panel.porta.scorrevole){
      // apertura
      var shape6 = new THREE.Shape();
      shape6.moveTo(p.wstipite,0);
      shape6.absarc(p.wstipite,0, p.w-p.wstipite*2, 0, Math.PI/2,  false );
      shape6.lineTo(p.wstipite,0);
    
      extrudedGeometry = new THREE.ExtrudeGeometry(shape6, {depth: 0,steps:1, bevelEnabled: true});
      extrudedMesh = new THREE.Mesh(extrudedGeometry, new THREE.MeshPhongMaterial({color: color}));
      geo211w = new THREE.EdgesGeometry( extrudedMesh.geometry,30 ); // or WireframeGeometry( geometry )
      mat11 = new THREE.LineBasicMaterial( { color: color , linewidth: 1 } );
      wirefr= new THREE.LineSegments( geo211w, mat11 );
      wirefr.translateZ(p.spessorebattente);
    
      if(panel.porta.tipoApertura!='DX'){
        wirefr.rotateX(Math.PI/2);
      } else {
        wirefr.rotateY(Math.PI);
        wirefr.rotateX(-1*Math.PI/2);
        wirefr.translateX(-1*p.w);
      }
      
      group.add( wirefr );
    }

    group.translateX(offsetX);
    group.translateY(offsetY);
    group.translateZ(offsetZ);
    
    if(side=='fronte'){
      group.rotateY(-1*Math.PI/2);
      group.translateZ(-1*p.spessorebattente);
      if(panel.porta.ruota180gradi){
        group.rotateY(Math.PI); 
        group.translateX(-1*p.w);
      }
    }
    if(side=='retro'){
      group.rotateY(Math.PI/2);
  //    group.translateZ(-1*p.spessorebattente);
      group.translateX(-1*p.w-1*p.spessorebattente);
      if(panel.porta.ruota180gradi){
        group.rotateY(Math.PI); 
        group.translateX(-1*p.w);
      }
    }
    if(side=='sn'){
      group.rotateY(Math.PI);
      group.translateZ(-1*p.spessorebattente);
      group.translateX(-1*p.w);
      if(panel.porta.ruota180gradi){
        group.rotateY(Math.PI); 
        group.translateX(-1*p.w);
      }
      
    }
    if(side=='ds'){
      if(panel.porta.ruota180gradi){
        group.rotateY(Math.PI); 
        group.translateX(-1*p.w);
      }
    }
   

    
    this.group.add( group );

  }

  
  disegnaVespaio(){
     let xPannello=this.mS.objVespaio.x;
     let yPannello=this.mS.objVespaio.y;
     let zPannello=this.mS.objVespaio.z;
     this.mS.objVespaio.pannelli.forEach((p:any) => {
        zPannello+=p.step;
        this.drawPanel(xPannello,yPannello,zPannello,p,'vespaio');
      });
  }

  /** Catalogo travi per portata: 320 = soffitto normale, 440 = soffitto MAXI. */
  private readonly catalogoTraviPortate: Record<string, { lunghezza: number; cod_comp: string; art_comp: string }[]> = {
    '320': [
      { lunghezza: 360, cod_comp: '5200000360', art_comp: 'MS095051' },
      { lunghezza: 380, cod_comp: '5200000380', art_comp: 'M1921431' },
      { lunghezza: 400, cod_comp: '5200000400', art_comp: 'MS095052' },
      { lunghezza: 420, cod_comp: '5200000420', art_comp: 'M1921432' },
      { lunghezza: 440, cod_comp: '5200000440', art_comp: 'MS095053' },
      { lunghezza: 460, cod_comp: '5200000460', art_comp: 'M1921433' },
      { lunghezza: 480, cod_comp: '5200000480', art_comp: 'MS095054' },
      { lunghezza: 500, cod_comp: '5200000500', art_comp: 'M1921434' },
      { lunghezza: 520, cod_comp: '5200000520', art_comp: 'MS095055' },
      { lunghezza: 540, cod_comp: '5200000540', art_comp: 'M1921435' },
      { lunghezza: 560, cod_comp: '5200000560', art_comp: 'MS095056' },
      { lunghezza: 580, cod_comp: '5200000580', art_comp: 'M1921436' },
      { lunghezza: 600, cod_comp: '5200000600', art_comp: 'MS095057' },
      { lunghezza: 620, cod_comp: '5200000620', art_comp: 'M1921437' },
      { lunghezza: 640, cod_comp: '5200000640', art_comp: 'MS095058' },
      { lunghezza: 660, cod_comp: '5200000660', art_comp: 'M1921438' },
      { lunghezza: 680, cod_comp: '5200000680', art_comp: 'MS095059' },
      { lunghezza: 700, cod_comp: '5300000700', art_comp: 'M1921534' },
      { lunghezza: 720, cod_comp: '5300000720', art_comp: 'MS095065' },
      { lunghezza: 740, cod_comp: '5300000740', art_comp: 'M1921535' },
      { lunghezza: 760, cod_comp: '5300000760', art_comp: 'MS095066' },
      { lunghezza: 780, cod_comp: '5300000780', art_comp: 'M1921536' },
      { lunghezza: 800, cod_comp: '5300000800', art_comp: 'MS095067' },
      { lunghezza: 820, cod_comp: '5300000820', art_comp: 'M1921537' },
      { lunghezza: 840, cod_comp: '5300000840', art_comp: 'MS095068' },
      { lunghezza: 880, cod_comp: '5400000880', art_comp: 'MS095074' },
      { lunghezza: 920, cod_comp: '5400000920', art_comp: 'MS095075' },
      { lunghezza: 960, cod_comp: '5400000960', art_comp: 'MS095076' },
      { lunghezza: 1000, cod_comp: '5400001000', art_comp: 'MS095077' },
      { lunghezza: 1040, cod_comp: '5400001040', art_comp: 'MS095078' },
      { lunghezza: 1080, cod_comp: '5400001080', art_comp: 'MS095079' },
      { lunghezza: 1120, cod_comp: '5400001120', art_comp: 'MS095080' },
      { lunghezza: 1160, cod_comp: '5500001160', art_comp: 'MS095087' },
      { lunghezza: 1200, cod_comp: '5500001200', art_comp: 'MS095088' },
      { lunghezza: 1240, cod_comp: '5900001240', art_comp: 'MS096281' },
      { lunghezza: 1280, cod_comp: '5900001280', art_comp: 'MS096282' },
      { lunghezza: 1320, cod_comp: '5900001320', art_comp: 'MS096283' },
      { lunghezza: 1360, cod_comp: '5900001360', art_comp: 'MS096284' },
      { lunghezza: 1400, cod_comp: '5900001400', art_comp: 'MS096285' },
      { lunghezza: 1440, cod_comp: '5900001440', art_comp: 'MS096286' },
      { lunghezza: 1480, cod_comp: '5900001480', art_comp: 'MS096287' },
      { lunghezza: 1520, cod_comp: '5900001520', art_comp: 'MS096288' },
      { lunghezza: 1560, cod_comp: '5900001560', art_comp: 'MS096289' },
    ],
    '440': [
      { lunghezza: 480, cod_comp: '5200000480', art_comp: 'MS095054' },
      { lunghezza: 500, cod_comp: '5200000500', art_comp: 'M1921434' },
      { lunghezza: 520, cod_comp: '5200000520', art_comp: 'MS095055' },
      { lunghezza: 540, cod_comp: '5200000540', art_comp: 'M1921435' },
      { lunghezza: 560, cod_comp: '5300000560', art_comp: 'MS095061' },
      { lunghezza: 580, cod_comp: '5300000580', art_comp: 'M1921531' },
      { lunghezza: 600, cod_comp: '5300000600', art_comp: 'MS095062' },
      { lunghezza: 620, cod_comp: '5300000620', art_comp: 'M1921532' },
      { lunghezza: 640, cod_comp: '5300000640', art_comp: 'MS095063' },
      { lunghezza: 660, cod_comp: '5300000660', art_comp: 'M1921533' },
      { lunghezza: 680, cod_comp: '5300000680', art_comp: 'MS095064' },
      { lunghezza: 700, cod_comp: '5300000700', art_comp: 'M1921534' },
      { lunghezza: 720, cod_comp: '5300000720', art_comp: 'MS095065' },
      { lunghezza: 740, cod_comp: '5300000740', art_comp: 'M1921535' },
      { lunghezza: 780, cod_comp: '5300000780', art_comp: 'M1921536' },
      { lunghezza: 820, cod_comp: '5300000820', art_comp: 'M1921537' },
      { lunghezza: 760, cod_comp: '5400000760', art_comp: 'MS095071' },
      { lunghezza: 800, cod_comp: '5400000800', art_comp: 'MS095072' },
      { lunghezza: 840, cod_comp: '5400000840', art_comp: 'MS095073' },
      { lunghezza: 880, cod_comp: '5400000880', art_comp: 'MS095074' },
      { lunghezza: 920, cod_comp: '5500000920', art_comp: 'MS095081' },
      { lunghezza: 960, cod_comp: '5500000960', art_comp: 'MS095082' },
      { lunghezza: 1000, cod_comp: '5500001000', art_comp: 'MS095083' },
      { lunghezza: 1040, cod_comp: '5500001040', art_comp: 'MS095084' },
      { lunghezza: 1080, cod_comp: '5500001080', art_comp: 'MS095085' },
      { lunghezza: 1120, cod_comp: '5500001120', art_comp: 'MS095086' },
      { lunghezza: 1160, cod_comp: '5500001160', art_comp: 'MS095087' },
      { lunghezza: 1200, cod_comp: '5500001200', art_comp: 'MS095088' },
      { lunghezza: 1240, cod_comp: '5900001240', art_comp: 'MS096281' },
      { lunghezza: 1280, cod_comp: '5900001280', art_comp: 'MS096282' },
      { lunghezza: 1320, cod_comp: '5900001320', art_comp: 'MS096283' },
      { lunghezza: 1360, cod_comp: '5900001360', art_comp: 'MS096284' },
      { lunghezza: 1400, cod_comp: '5900001400', art_comp: 'MS096285' },
      { lunghezza: 1440, cod_comp: '5900001440', art_comp: 'MS096286' },
      { lunghezza: 1480, cod_comp: '5900001480', art_comp: 'MS096287' },
      { lunghezza: 1520, cod_comp: '5900001520', art_comp: 'MS096288' },
      { lunghezza: 1560, cod_comp: '5900001560', art_comp: 'MS096289' },
    ],
  };

  /** Trova cod_comp trave per lunghezza e portata (320 / 440). */
  private findCodCompTrave(lungh: number, portata: string): string | null {
    const list = this.catalogoTraviPortate[portata] || [];
    const hit = list.find((t) => t.lunghezza === lungh);
    return hit?.cod_comp || null;
  }

  disegnaTravi(){
    let c=320;
    let lung=this.mS.objCella.w;
    let larg=this.mS.objCella.d;
    if(this.mS.cellaDati.ruotasoffitto){
      lung=this.mS.objCella.d;
      larg=this.mS.objCella.w;
    }
    this.mS.objTravi=[];
    // portata 440 se soffitto MAXI, altrimenti 320
    const portata = this.mS.cellaDati.soffittoMAXI ? '440' : '320';
    const codComp = this.findCodCompTrave(lung, portata);

    if(larg>320){
      let extrudedGeometry=this.creaTrave2(lung);
      let lunghp:any=[];
    
      this.mS.cellaDati.combPannelliSoffitto.forEach((curp:any,ind:number)=>{
          if(ind<this.mS.cellaDati.combPannelliSoffitto.length-1){
            for(let q:number=0;q<curp.count;q++){
              lunghp.push(curp.segment);
            }
          } else {
            for(let q:number=0;q<curp.count-1;q++){
              lunghp.push(curp.segment);
            }      
          }
      });
        
      let cind=0;
      c=lunghp[cind];
      while(c<larg){
      
        let eg=extrudedGeometry.clone();
        if(!this.mS.cellaDati.ruotasoffitto){
            eg.rotateY(Math.PI/2);
            eg.translate(0,this.mS.objCella.h,c);
        } else {
            eg.translate(c,this.mS.objCella.h,0);
        }
        this.addWireframeToScene(eg, 0xff0000);

        // solo se la lunghezza è nel catalogo della portata
        if (codComp) {
          this.mS.objTravi.push({
            name: codComp,
            qty: 1,
          });
        }
        cind++;
        c+=lunghp[cind];
      }
    }

    // Celle unite: sul tratto comune (pannelli fittizio, senza angolare a soffitto) una trave se >320
    this.disegnaTraviUniteContatti(portata);

    this.mS.objCella.objTravi=this.mS.objTravi;
     
  }

  /** Tratti contiguui di pannelli fittizio (esclusi sopraporta) su un lato. */
  private getTrattiFittizioLato(pannelli: any[]): { start: number; len: number }[] {
    const out: { start: number; len: number }[] = [];
    let cursor = 0;
    let runStart = 0;
    let runLen = 0;
    (pannelli || []).forEach((p: any) => {
      if (p?.sopraporta) {
        return;
      }
      const w = Number(p?.w) || 0;
      if (p?.fittizio) {
        if (runLen === 0) {
          runStart = cursor;
        }
        runLen += w;
      } else if (runLen > 0) {
        out.push({ start: runStart, len: runLen });
        runLen = 0;
      }
      cursor += w;
    });
    if (runLen > 0) {
      out.push({ start: runStart, len: runLen });
    }
    return out;
  }

  private getObjLatoByNome(lato: string): any {
    switch (lato) {
      case 'lato_fronte':
        return this.mS.objCella?.objFronte;
      case 'lato_retro':
        return this.mS.objCella?.objRetro;
      case 'lato_sn':
        return this.mS.objCella?.objLatSin;
      case 'lato_ds':
        return this.mS.objCella?.objLatDs;
      default:
        return null;
    }
  }

  /**
   * Su collegamenti unite, dove l'angolare a soffitto è interrotto dai pannelli fittizio,
   * disegna una trave sul tratto comune (solo se lunghezza > 320) e la registra in objTravi.
   */
  disegnaTraviUniteContatti(portata: string) {
    const links = (this.mS.cellaDati?.celleCollegate || []).filter(
      (x: any) => x?.attivo && x?.tipoCollegamento === 'unite' && x?.latocollegato
    );
    if (!links.length) {
      return;
    }

    const h = this.mS.objCella.h;
    const w = this.mS.objCella.w;
    const d = this.mS.objCella.d;

    links.forEach((link: any) => {
      const objLato = this.getObjLatoByNome(link.latocollegato);
      const tratti = this.getTrattiFittizioLato(objLato?.pannelli);
      tratti.forEach((tratto) => {
        if (tratto.len <= 339) {
          return;
        }

        

        const eg = this.creaTrave2(tratto.len);
        switch (link.latocollegato) {
          case 'lato_fronte':
            // fronte: pannelli lungo Z, trave lungo il tratto comune
            eg.translate(0, h, tratto.start);
            break;
          case 'lato_retro':
            eg.translate(w, h, tratto.start);
            break;
          case 'lato_sn':
            // sn: pannelli lungo X
            eg.rotateY(Math.PI / 2);
            eg.translate(tratto.start, h, 0);
            break;
          case 'lato_ds':
            eg.rotateY(Math.PI / 2);
            eg.translate(tratto.start, h, d);
            break;
          default:
            return;
        }
        this.addWireframeToScene(eg, 0xff0000);

        const codComp = this.findCodCompTrave(tratto.len, portata);
        if (codComp) {
          this.mS.objTravi.push({
            name: codComp,
            qty: 1,
          });
        }
      });
    });
  }
  
  creaTrave2(lungh:number){
    let larrgT=25;
    let shape = new THREE.Shape();
    shape.moveTo(0,0);
    shape.lineTo(larrgT,0);
    shape.lineTo(larrgT/2,larrgT);
    shape.lineTo(0,0);
    var extrudedGeometry = new THREE.ExtrudeGeometry(shape, {depth: lungh,steps:10, bevelEnabled: true});
    return extrudedGeometry;
  }
  
  drawTrave(c:number,side:string){
    let wirefr:any=null;
    let transY=this.mS.cellaDati.altezza;
    if(side=='fronte'){
      let wirefr=this.creaTrave(c,this.mS.objCella.d,side);
        wirefr.rotateZ(Math.PI);
        wirefr.translateY(transY);
        this.group.add( wirefr );
    } else {
      // pav lato ds
          wirefr=this.creaTrave(c,this.mS.objCella.w,side);
          wirefr.rotateZ(Math.PI);
          wirefr.rotateY(Math.PI/2);
          wirefr.translateY(transY);
          wirefr.translateZ(-1*c);
          this.group.add( wirefr );
    }
        
     
  }
  
  creaTrave(c:number,lungh:number,side:string){
   
    let larrgT=55;
    
    let shape = new THREE.Shape();
    shape.lineTo(larrgT,0);
    shape.lineTo(larrgT/2,larrgT);
    shape.lineTo(this.latoAngolare,0);
    let geoShape = new THREE.ShapeGeometry( shape ); 
    let shape1=shape.clone();
    let geoShape1 = new THREE.ShapeGeometry( shape1 );
    geoShape1.translate(0,0,lungh);
    let mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
    let geox = new THREE.EdgesGeometry( geoShape,30 ); // or WireframeGeometry( geometry )
    let wire= new THREE.LineSegments( geox, mat );
    wire.updateMatrix();
    let geox1 = new THREE.EdgesGeometry( geoShape1,30 ); // or WireframeGeometry( geometry )
    let wire1= new THREE.LineSegments( geox1, mat );
    wire1.updateMatrix();
    wire.updateMatrix();

    let shape2 = new THREE.Shape();
    shape2.lineTo(0,lungh);
    let geoShape2 = new THREE.ShapeGeometry( shape2 );
    geoShape2.rotateY(Math.PI/2);
    let geox2 = new THREE.EdgesGeometry( geoShape2,30 ); // or WireframeGeometry( geometry )
    let wire2= new THREE.LineSegments( geox2, mat );
    const group = new THREE.Group();
    group.add( wire );
    group.add( wire1 );
    group.add( wire2 );
    
    return group;
    
  }
  
  addSpigolo(x:number,y:number,lato:string){

    if(!this.configurazioneCelle.spigoli){
      this.configurazioneCelle.spigoli=[];
    }

    if(this.configurazioneCelle.spigoli.filter((s:any)=>s.x==x && s.y==y).length==0){
      this.configurazioneCelle.spigoli.push({
        x:x,
        y:y,
        spigoli:[lato]
      });
    } else {
      this.configurazioneCelle.spigoli[this.configurazioneCelle.spigoli.findIndex((s:any)=>s.x==x && s.y==y)].spigoli.push(lato);
    }
   
  }
 
  disegnaPannelli(xinit:number,zinit:number){
   
    let xPannello=this.mS.objSoffitto.x;
    let yPannello=this.mS.objSoffitto.y+this.mS.cellaDati.spessore;
    let zPannello=this.mS.objSoffitto.z;
    let last=0;
    this.mS.objSoffitto.pannelli.forEach((p:any,ind:number) => {
      if(!this.mS.cellaDati.ruotasoffitto){
        
        if(p.z && p.z>0){
          zPannello=this.mS.objSoffitto.z+p.z;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        } else {
          zPannello=this.mS.objSoffitto.z;
          xPannello+=last;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        }
        last=p.w;
      }else {
        if(p.z && p.z>0){
          xPannello=this.mS.objSoffitto.z+p.z;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        } else {
          xPannello=this.mS.objSoffitto.z;
          zPannello+=last;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        }
        last=p.h;
      }
    });


    if(this.mS.cellaDati.pavimenti){
      last=0;
      xPannello=this.mS.objPavimento.x;
      yPannello=this.mS.objPavimento.y-this.mS.cellaDati.spessore;
      zPannello=this.mS.objPavimento.z;
      this.mS.objPavimento.pannelli.forEach((p:any) => {
        if(!this.mS.cellaDati.ruotaPavimento){
          if(p.z && p.z>0){
            zPannello=this.mS.objPavimento.z+p.z;
            this.drawPanel(xPannello,yPannello,zPannello,p,'pavimento');
          } else {
            zPannello=this.mS.objPavimento.z;
            xPannello+=last;
            this.drawPanel(xPannello,yPannello,zPannello,p,'pavimento');
          }
          last=p.w;
        } else {
          if(p.z && p.z>0){
            xPannello=this.mS.objSoffitto.x+p.z;
            this.drawPanel(xPannello,yPannello,zPannello,p,'pavimento');
          } else {
            xPannello=this.mS.objSoffitto.z;
            zPannello+=last;
            this.drawPanel(xPannello,yPannello,zPannello,p,'pavimento');
          }
          last=p.h;
        }
        
      });
    }
   

    // Divisorio/combinate orizzontale (cella a sinistra, corrZ<0 / shiftLeft):
    // il gruppo è già traslato di −(sp+3); sn+fronte+retro restano locali (quindi
    // in world si spostano a sinistra); il ds (divisorio) viene riposizionato di
    // +shiftLeft in locale così resta fermo; fronte/retro si allungano verso ds.
    const distaccoSpigolo = 1.5;
    const divExtra = this.getDivisorioTraslaExtra(this.mS.cellaDati);
    const corrZ = divExtra.dOx; // <0 → cella a sinistra
    const corrX = divExtra.dOy; // moto ±oy → sn/ds
    const shiftLeft = corrZ < 0 ? -corrZ : 0;
    const dxLibFronte = 0;
    const dxLibRetro = 0;
    const dzLibSn = 0;
    const dzLibDs = 0;

    const sumPannelliLato = (obj: any): number =>
      (obj?.pannelli || [])
        .filter((p: any) => !p.sopraporta)
        .reduce((s: number, p: any) => s + (Number(p.w) || 0), 0);
    const lunghFR =
      sumPannelliLato(this.mS.objFronte) ||
      sumPannelliLato(this.mS.objRetro) ||
      this.mS.cellaDati.ingombroX ||
      0;
    const lunghLat =
      sumPannelliLato(this.mS.objLatSin) ||
      sumPannelliLato(this.mS.objLatDs) ||
      this.mS.cellaDati.ingombroY ||
      0;

    const altezzaParete = this.mS.cellaDati.altezza || this.mS.objCella?.h || 0;
    const drawEstensione = (
      x0: number,
      y0: number,
      z0: number,
      len: number,
      side: string,
    ) => {
      if (len <= 0.5) {
        return;
      }
      const panelSide =
        side === 'fronte' || side === 'retro' ? 'fronte_retro' : 'laterale';
      const ext: any = {
        side: panelSide,
        w: len,
        h: altezzaParete,
        d: this.mS.cellaDati.spessore,
        name: '',
        text: '',
      };
      this.drawPanel(x0, y0, z0, ext, side);
    };

    // fronte: pannelli normali, poi estensione verso ds (divisorio fermo)
    xPannello=this.mS.objFronte.x-this.mS.cellaDati.spessore-distaccoSpigolo + dxLibFronte;
    yPannello=this.mS.objFronte.y;
    zPannello=this.mS.objFronte.z;
    let zeta=0;
    this.mS.objFronte.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any,ind:number) => {
      this.drawPanel(xPannello,yPannello,zPannello,p,'fronte');
      zeta=zPannello;
      zPannello+=p.w;
    });
    if (shiftLeft > 0) {
      drawEstensione(xPannello, yPannello, zPannello, shiftLeft, 'fronte');
      zPannello += shiftLeft;
      zeta = zPannello;
    }
    if(zeta>0){
      this.addSpigolo(xinit+zPannello,zinit+lunghLat,'fronte_end');
      this.addSpigolo(xinit,zinit+lunghLat,'fronte_start');
    }

    xPannello=this.mS.objRetro.x+distaccoSpigolo + dxLibRetro;
    yPannello=this.mS.objRetro.y;
    zPannello=this.mS.objRetro.z;
    zeta=0;
    this.mS.objRetro.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any) => {
      this.drawPanel(xPannello,yPannello,zPannello,p,'retro');
      zeta=zPannello;
      zPannello+=p.w;
    });
    if (shiftLeft > 0) {
      drawEstensione(xPannello, yPannello, zPannello, shiftLeft, 'retro');
      zPannello += shiftLeft;
      zeta = zPannello;
    }
   if(zeta>0){
      this.addSpigolo(xinit+zPannello,zinit,'retro_end');
      this.addSpigolo(xinit,zinit,'retro_start');
    }

    // sn: segue il gruppo (spostato a sinistra); ds: +shiftLeft → resta sul divisorio
    xPannello=this.mS.objLatSin.x - (corrX > 0 ? corrX : 0);
    yPannello=this.mS.objLatSin.y;
    zPannello=this.mS.objLatSin.z-this.mS.cellaDati.spessore-distaccoSpigolo + dzLibSn;
    if (corrX > 0) {
      drawEstensione(xPannello, yPannello, zPannello, corrX, 'sn');
      xPannello += corrX;
    }
    this.mS.objLatSin.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any) => {
      this.drawPanel(xPannello,yPannello,zPannello,p,'sn');
      xPannello+=p.w;
    });
    if (corrX < 0) {
      drawEstensione(xPannello, yPannello, zPannello, -corrX, 'sn');
      xPannello += -corrX;
    }

    xPannello=this.mS.objLatDs.x - (corrX > 0 ? corrX : 0);
    yPannello=this.mS.objLatDs.y;
    zPannello=this.mS.objLatDs.z+distaccoSpigolo + dzLibDs + shiftLeft;
    if (corrX > 0) {
      drawEstensione(xPannello, yPannello, zPannello, corrX, 'ds');
      xPannello += corrX;
    }
   this.mS.objLatDs.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any) => {
      this.drawPanel(xPannello,yPannello,zPannello,p,'ds');
      xPannello+=p.w;
    });
    if (corrX < 0) {
      drawEstensione(xPannello, yPannello, zPannello, -corrX, 'ds');
      xPannello += -corrX;
    }
 
    this.mS.objDivisori.forEach((divisore:any)=>{
      xPannello=divisore.x;
      yPannello=divisore.y;
      zPannello=divisore.z;
      divisore.pannelli.filter((x:any)=>!x.sopraporta).forEach((p:any) => {
        let side='';
        if(divisore.type=='divisorioorizz'){
           side='fronte';
          if(p.porta && p.porta.lato_porta=='lato_retro'){
            side='retro';
          }
          if(p.porta && p.porta.lato_porta=='lato_fronte'){
            side='fronte';
          }
          this.drawPanel(xPannello,yPannello,zPannello,p,side);
          zPannello+=p.w;
        } else {
          side='sn';
          if(p.porta && p.porta.lato_porta=='lato_sn'){
            side='sn';
          }
          if(p.porta && p.porta.lato_porta=='lato_ds'){
            side='ds';
          }
          this.drawPanel(xPannello,yPannello,zPannello,p,side);
          xPannello+=p.w;
        }
      });
    });

  }

drawTextPanel(side:string,offsetX:number,offsetY:number,offsetZ:number,panel:any,testo:string){

      let obj:any={};
      if(side=='sn'){
         obj={
            x:offsetX+panel.w/2,
            y:offsetY+panel.h/2,
            z:offsetZ,
            setSizeX:0,
            setSizeY:1,
            setSizeZ:0,
            rotationX:0,
            rotationY:Math.PI,//-1*Math.PI,
            rotationZ:Math.PI*1.5,
            text:testo
          };
        
      }
      if(side=='ds'){
         obj={
            x:offsetX+panel.w/2,
            y:offsetY+panel.h/2,
            z:offsetZ,
            setSizeX:0,
            setSizeY:1,
            setSizeZ:0,
            rotationX:0,
            rotationY:0,//-1*Math.PI,
            rotationZ:Math.PI*1.5,
            text:testo
          };
      }
      if(side=='fronte' || side=='fronte_sopraporta'){
         obj={
            x:offsetX,
            y:offsetY+panel.h/2,
            z:offsetZ+panel.w/2,
            setSizeX:0,
            setSizeY:1,
            setSizeZ:0,
            rotationX:0,
            rotationY:  -1*Math.PI/2,//-1*Math.PI,
            rotationZ:Math.PI*1.5,
            text:testo
          };
      }
      if(side=='retro'){
         obj={
            x:offsetX,
            y:offsetY+panel.h/2,
            z:offsetZ+panel.w/2,
            setSizeX:0,
            setSizeY:1,
            setSizeZ:0,
            rotationX:0,
            rotationY:Math.PI/2,//-1*Math.PI,
            rotationZ:Math.PI*1.5,
            text:testo
          };
      }
      this.drawText(obj);
}

drawPanel(offsetX:number,offsetY:number,offsetZ:number,panel:any,side:string){
  if(panel.fittizio){
    return;
  }

  var geometry:any=null;
  var geo:any=null;
  var wireframe=null;
  var mat = new THREE.LineBasicMaterial( { 
    color: 0xffffff, linewidth: 1 } );
  var m= new THREE.MeshBasicMaterial({
    transparent: true,
    opacity: 0.3,
  });
  var colorPannello=this.mS.pannelloAzzurroHex;
  if(this.mS.cellaDati.finitura=='STANDARD'){
    colorPannello=this.mS.pannelloPannaHex;
  } 
  
  if(panel.w==31 || panel.w==27){
    colorPannello=0xffaa33;
  }

  if(panel.side=='laterale'){


    let testo=''+(panel.w*10)+' x '+ (panel.h*10);
   

    
    if(panel.porta){
      this.drawPorta(offsetX,offsetY,offsetZ,panel,side);
      let panelh=panel.h;
      panel.h= this.mS.cellaDati.altezza-panel.h;
      let glass:any=this.fillPanel(panel.w, panel.h, panel.d,colorPannello);
      geometry = new THREE.BoxGeometry(panel.w, panel.h, panel.d);
      geometry.translate( panel.w/2+offsetX, panel.h/2+offsetY, panel.d/2 +offsetZ);
      glass.translateX( panel.w/2+offsetX);
      glass.translateY( panel.h/2+offsetY);
      glass.translateY( panelh);
      glass.translateZ( panel.d/2 +offsetZ);
      this.group.add( glass );
      geo = new THREE.EdgesGeometry( geometry,30 ); 
      wireframe = new THREE.LineSegments( geo, mat );

      this.drawTextPanel(side,offsetX,offsetY+panelh,offsetZ,panel,testo);
      this.group.add( wireframe );

    } else {
      // panel.h per freeblock è già altezza cella - 40 (non sottrarre di nuovo)
      let panelh=panel.h;
      let glass:any=this.fillPanel(panel.w, panelh, panel.d,colorPannello);
      geometry = new THREE.BoxGeometry(panel.w, panelh, panel.d);
      geometry.translate( panel.w/2+offsetX, panelh/2+offsetY, panel.d/2 +offsetZ);
      glass.translateX( panel.w/2+offsetX);
      glass.translateY( panelh/2+offsetY);
      glass.translateZ( panel.d/2 +offsetZ);
      this.group.add( glass );
      geo = new THREE.EdgesGeometry( geometry,30 ); 
      wireframe = new THREE.LineSegments( geo, mat );

      this.drawTextPanel(side,offsetX,offsetY,offsetZ,panel,testo);
      this.group.add( wireframe );


    }
   
  }
  if((panel.side=='soffitto')||(panel.side=='pavimento')){
    geometry = new THREE.BoxGeometry(panel.w, panel.d, panel.h);
    geometry.translate( panel.w/2+offsetX, panel.d/2+offsetY, panel.h/2 +offsetZ);
    geo = new THREE.EdgesGeometry( geometry,30 ); 
    wireframe = new THREE.LineSegments( geo, mat );
    let zrotaion=0.5*Math.PI;
    if(this.mS.cellaDati.ruotasoffitto){
      zrotaion=Math.PI;
    }
     let obj={
      x:offsetX+panel.w/2,
      y:panel.d/2+offsetY,
      z:offsetZ+panel.h/2,
      setSizeX:0,
      setSizeY:1,
      setSizeZ:0,
      rotationX:1.5*Math.PI,
      rotationY:0,
      rotationZ:zrotaion,
      text:''+(panel.w*10)+' x '+ (panel.h*10)
    };
    this.drawText(obj);
  
    this.group.add( wireframe );
  }
  if(panel.side=='vespaio'){
    let glass:any=this.fillPanel(panel.d, panel.h, panel.w,this.mS.colorevespaioHex);
    geometry =  new THREE.BoxGeometry(panel.d, panel.h, panel.w);
    geometry.translate( panel.d/2+offsetX, panel.h/2+offsetY, panel.w/2 +offsetZ);
    glass.translateX( panel.d/2+offsetX);
    glass.translateY( panel.h/2+offsetY);
    glass.translateZ( panel.w/2 +offsetZ);
    this.group.add( glass );
    geo = new THREE.EdgesGeometry( geometry,30 ); 
    wireframe = new THREE.LineSegments( geo, mat );
    this.group.add( wireframe );
  }

  if(panel.side=='fronte_retro'){
    if(panel.porta){
      this.drawPorta(offsetX,offsetY,offsetZ,panel,side);
      let panelh=panel.h;
      panel.h= this.mS.cellaDati.altezza-panel.h;
      let glass:any=this.fillPanel(panel.d,panel.h, panel.w,colorPannello);
      geometry =  new THREE.BoxGeometry(panel.d, panel.h, panel.w);
      geometry.translate( panel.d/2+offsetX, panel.h/2+offsetY, panel.w/2 +offsetZ);
      glass.translateX( panel.d/2+offsetX);
      glass.translateY( panel.h/2+offsetY);
      glass.translateY( panelh);
      glass.translateZ( panel.w/2 +offsetZ);
      this.group.add( glass );
      geo = new THREE.EdgesGeometry( geometry,30 ); 
      wireframe = new THREE.LineSegments( geo, mat );
      this.drawTextPanel('fronte_sopraporta',offsetX,offsetY+panelh,offsetZ,panel,''+(panel.w*10)+' x '+ (panel.h*10));
      this.group.add( wireframe );
      
    } else {
      let glass:any=this.fillPanel(panel.d, panel.h, panel.w,colorPannello);
      geometry =  new THREE.BoxGeometry(panel.d, panel.h, panel.w);
      geometry.translate( panel.d/2+offsetX, panel.h/2+offsetY, panel.w/2 +offsetZ);
      glass.translateX( panel.d/2+offsetX);
      glass.translateY( panel.h/2+offsetY);
      glass.translateZ( panel.w/2 +offsetZ);
      this.group.add( glass );
      geo = new THREE.EdgesGeometry( geometry,30 ); 
      wireframe = new THREE.LineSegments( geo, mat );
      this.drawTextPanel(side,offsetX,offsetY,offsetZ,panel,''+(panel.w*10)+' x '+ (panel.h*10));
      this.group.add( wireframe );
      
      
      
    }
  }
  

}
/*
drawPannello(x:number,y:number,z:number,dimPannello:any,dimAng:any,dimlato:any,faccia:string){
 
  var m= new THREE.MeshBasicMaterial({
    transparent: true,
    opacity: 0.3,
  });
  
  var geometryLateral = new THREE.BoxGeometry(dimPannello.width, dimPannello.height, dimPannello.depth);
  var pan = new THREE.Mesh(geometryLateral, m);
  if(faccia=='laterale_davanti'){
    pan.position.x=x+dimPannello.width/2;
    pan.position.y=y+dimPannello.height/2;
    pan.position.z=z;
     this.text('pppp',0,0,0,0,0,Math.PI,true);
  //  this.text(''+(dimPannello.width*10),dimPannello.width/2,0,-16,-Math.PI/2,0,Math.PI,true);
  }
  
  //  mesh.rotation.x=-Math.PI/2;
  //  mesh.rotation.z=Math.PI;
  this.scene.add(pan);
   
}

drawAngolare(x:number,y:number,z:number,dimAng:any,dimlato:any,faccia:string,orientamento:string){
 
  let wireframe:any;

  if(faccia=='laterale'){
    if(orientamento=='v'){
      var geometryLateral = new THREE.BoxGeometry(dimAng.width, dimAng.height, dimAng.depth);
      var geo = new THREE.EdgesGeometry( geometryLateral ); // or WireframeGeometry( geometry )
      var mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
      wireframe = new THREE.LineSegments( geo, mat );
      wireframe.position.x=x;
      wireframe.position.y=dimAng.height/2;
      wireframe.position.z=z;
    } else{
      var geometryLateral = new THREE.BoxGeometry(dimAng.width, dimlato.width, dimAng.depth);
      var geo = new THREE.EdgesGeometry( geometryLateral ); // or WireframeGeometry( geometry )
      var mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
      wireframe = new THREE.LineSegments( geo, mat );
      wireframe.rotation.z=Math.PI/2;
      wireframe.position.x=dimlato.width/2;
      wireframe.position.y=y;
      wireframe.position.z=z;
    }
  }
  if(faccia=='fronte_retro'){
    var geometryLateral = new THREE.BoxGeometry(dimAng.width, dimlato.depth, dimAng.depth);
    var geo = new THREE.EdgesGeometry( geometryLateral ); // or WireframeGeometry( geometry )
    var mat = new THREE.LineBasicMaterial( { color: 0xffffff, linewidth: 1 } );
    wireframe = new THREE.LineSegments( geo, mat );
    wireframe.rotation.x=Math.PI/2;
    wireframe.position.x=x;
    wireframe.position.y=y;
    wireframe.position.z=dimlato.depth/2;
  }
 
  this.scene.add(wireframe );
}
*/
drawText(obj:any){
  
    const textGeo = new TextGeometry( obj.text, this.fontProperties);
      var m= new THREE.MeshBasicMaterial({
        color:this.fontColor
      });
      
      textGeo.rotateZ(obj.rotationZ);
      textGeo.rotateX(obj.rotationX);
      textGeo.rotateY(obj.rotationY);
  
      
      
      const mesh = new THREE.Mesh( textGeo, m );  
    
      const size = new THREE.Vector3();
      mesh.geometry.computeBoundingBox();
      mesh.geometry.boundingBox?.getSize(size);
      mesh.position.set(obj.x+obj.setSizeX*size.x/2, obj.y+obj.setSizeY*size.y/2, obj.z+obj.setSizeZ*size.z/2 );
 
       this.group.add( mesh );

}

text(txt:string,x:number,y:number,z:number,rx:number,ry:number,rz:number,addSize:boolean){
  const loader = new FontLoader();
  loader.load(this.fontName,  ( font ) =>{
    this.fontProperties.font=font;
    const textGeo = new TextGeometry( txt, this.fontProperties);
      var m= new THREE.MeshBasicMaterial({
        color:this.fontColor
      });
      const mesh = new THREE.Mesh( textGeo, m );  
      mesh.rotation.x=rx;
      mesh.rotation.y=ry;
      mesh.rotation.z=rz;
 
      const size = new THREE.Vector3();
      mesh.geometry.computeBoundingBox();
      mesh.geometry.boundingBox?.getSize(size);
      if(addSize){
        mesh.position.set(x+size.x/2, y, z );
      } else {
        mesh.position.set(x-size.x/2, y, z );
      }
    
      this.scene.add( mesh );
  } );
}


  animate(): void {
      requestAnimationFrame(() => this.animate());
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
  }
  dopdf(){
    this.mS.pdf_soffitto();
  }

  clear(){
    if(this.scene && this.scene.children){
      for( var i = this.scene.children.length - 1; i >= 0; i--) { 
          let obj = this.scene.children[i];
          this.scene.remove(obj); 
          }
    }
  }


  deleteObject(object: any){
    object.geometry.dispose();

    if (object.material instanceof Array) {
      object.material.forEach((material:any) => material.dispose());
    } else {
        object.material.dispose();
    }
    object.removeFromParent()
    this.scene.remove(object);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  /**
   * Unite su `lato` che forma angolo 270° (contatto parziale o celle di diversa lunghezza):
   * in quel caso l'asta angolare è spessore+3 e la posizione 3D va allineata ai pannelli.
   */
  isUniteAngolo270(cella: any, lato: string): boolean {
    const links = (cella?.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'unite' &&
        x.latocollegato === lato,
    );
    if (!links.length) {
      return false;
    }
    const dimThis =
      lato === 'lato_sn' || lato === 'lato_ds' ? cella.ingombroY : cella.ingombroX;
    return links.some((l: any) => {
      const other = (this.configurazioneCelle?.elencoCelle || []).find(
        (c: any) => c.id == l.cellaCollegataId,
      );
      if (!other) {
        return false;
      }
      const dimOther =
        lato === 'lato_sn' || lato === 'lato_ds' ? other.ingombroY : other.ingombroX;
      if (dimThis != dimOther) {
        return true;
      }
      if ((l.distLato || 0) > 0) {
        return true;
      }
      if ((l.larghezza || 0) > 0 && l.larghezza < dimThis - 0.5) {
        return true;
      }
      return false;
    });
  }

  /**
   * Cella più lunga: sposta il muro LIBERO di sp+3 verso la corta.
   * Il contatto può essere:
   * - sullo stesso lato (tratto parziale)
   * - sul lato opposto (es. corta sopra → link su fronte, libero = retro)
   * - su un solo lato perpendicolare (L a un angolo: link sn|ds → libero fronte/retro)
   * Non usare due link laterali insieme (T a due angoli): lì il retro resta a 0.
   */
  getOffsetLiberoGrandePerCorta(lato: string): { dx: number; dz: number } {
    const out = { dx: 0, dz: 0 };
    const cella = this.mS.cellaDati;
    const config = this.configurazioneCelle;
    if (!cella || !config) {
      return out;
    }
    const opposite: Record<string, string> = {
      lato_fronte: 'lato_retro',
      lato_retro: 'lato_fronte',
      lato_sn: 'lato_ds',
      lato_ds: 'lato_sn',
    };
    const allDiv = (cella.celleCollegate || []).filter(
      (x: any) => x.attivo && x.tipoCollegamento === 'collegateDivisorio',
    );
    const same = allDiv.filter((x: any) => x.latocollegato === lato);
    const opp = allDiv.filter((x: any) => x.latocollegato === opposite[lato]);
    const latLinks = allDiv.filter(
      (x: any) => x.latocollegato === 'lato_sn' || x.latocollegato === 'lato_ds',
    );
    const frLinks = allDiv.filter(
      (x: any) =>
        x.latocollegato === 'lato_fronte' || x.latocollegato === 'lato_retro',
    );

    // priorità: stesso lato → opposto → un solo perpendicolare (un angolo)
    let links = same.length ? same : opp;
    if (!links.length) {
      if (
        (lato === 'lato_fronte' || lato === 'lato_retro') &&
        latLinks.length === 1
      ) {
        links = latLinks;
      } else if (
        (lato === 'lato_sn' || lato === 'lato_ds') &&
        frLinks.length === 1
      ) {
        links = frLinks;
      }
    }
    if (!links.length) {
      return out;
    }

    const delta = (cella.spessore || 0) + 3;
    let dx = 0;
    let dz = 0;
    let applied = false;
    links.forEach((link: any) => {
      if (applied) {
        return;
      }
      const other = (config.elencoCelle || []).find(
        (c: any) => c.id == link.cellaCollegataId,
      );
      if (!other) {
        return;
      }
      const linkLato = link.latocollegato;
      const dimThis =
        linkLato === 'lato_sn' || linkLato === 'lato_ds'
          ? cella.ingombroY || 0
          : cella.ingombroX || 0;
      const dimOther =
        linkLato === 'lato_sn' || linkLato === 'lato_ds'
          ? other.ingombroY || 0
          : other.ingombroX || 0;
      // solo se questa cella è più lunga sul lato di contatto
      if (dimThis <= dimOther + 0.5) {
        return;
      }
      // offset sul muro che stiamo disegnando (`lato`), non sul link
      switch (lato) {
        case 'lato_retro':
          dx += delta;
          break;
        case 'lato_fronte':
          dx -= delta;
          break;
        case 'lato_sn':
          dz += delta;
          break;
        case 'lato_ds':
          dz -= delta;
          break;
        default:
          break;
      }
      applied = true;
    });
    return { dx, dz };
  }

  /**
   * True se la cella ha un `unite` attivo su un lato perpendicolare a `lato`
   * (es. divisorio su retro + unite su sn/ds). In quel caso lo shift gap del
   * divisorio non va applicato solo a questa cella (disallineerebbe la gemella).
   */
  hasUnitePerpendicolareAlLato(cella: any, lato: string): boolean {
    const perp =
      lato === 'lato_fronte' || lato === 'lato_retro'
        ? ['lato_sn', 'lato_ds']
        : ['lato_fronte', 'lato_retro'];
    return (cella?.celleCollegate || []).some(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'unite' &&
        perp.includes(x.latocollegato),
    );
  }

  /**
   * Divisorio: questa cella deve allontanarsi dal vicino su `link`?
   * - lato più corto → sì
   * - lato più lungo → no (resta, parete in posizione normale)
   * - uguali → sì solo se !latocombinato (come combinate)
   */
  deveAllontanareDaDivisorio(cella: any, link: any): boolean {
    if (!cella || !link?.attivo || link.tipoCollegamento !== 'collegateDivisorio') {
      return false;
    }
    const lato = link.latocollegato;
    const other = (this.configurazioneCelle?.elencoCelle || []).find(
      (c: any) => c.id == link.cellaCollegataId,
    );
    if (!other) {
      return !link.latocombinato;
    }
    const dimThis =
      lato === 'lato_sn' || lato === 'lato_ds'
        ? cella.ingombroY || 0
        : cella.ingombroX || 0;
    const dimOther =
      lato === 'lato_sn' || lato === 'lato_ds'
        ? other.ingombroY || 0
        : other.ingombroX || 0;
    if (dimThis < dimOther) {
      return true;
    }
    if (dimThis > dimOther) {
      return false;
    }
    return !link.latocombinato;
  }

  /**
   * Divisorio / combinate: extra usato in disegnaPannelli (e oy in drawConfigurazione).
   * - verticale: +sp+3 solo sulla cella sotto (lato_retro) → dOy
   * - orizzontale: −sp+3 sulla più a sinistra → dOx (sn+FR si spostano; ds resta)
   * Se sul retro c’è già unite, nessun dOy.
   */
  getDivisorioTraslaExtra(
    cella: any,
    memo: Map<any, { dOx: number; dOy: number }> = new Map(),
  ): { dOx: number; dOy: number } {
    if (!cella?.id) {
      return { dOx: 0, dOy: 0 };
    }
    if (memo.has(cella.id)) {
      return memo.get(cella.id)!;
    }
    memo.set(cella.id, { dOx: 0, dOy: 0 });

    const hasUniteOnRetro = (cella.celleCollegate || []).some(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'unite' &&
        x.latocollegato === 'lato_retro',
    );

    const delta = (cella.spessore || 0) + 3;
    let dOx = 0;
    let dOy = 0;
    const links = (cella.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        (x.tipoCollegamento === 'collegateDivisorio' ||
          x.tipoCollegamento === 'combinate'),
    );

    links.forEach((link: any) => {
      const other = (this.configurazioneCelle?.elencoCelle || []).find(
        (c: any) => c.id == link.cellaCollegataId,
      );
      if (!other) {
        return;
      }
      const o = this.getDivisorioTraslaExtra(other, memo);
      const topThis = cella.offsetY3d || 0;
      const topOther = other.offsetY3d || 0;
      const isDiv = link.tipoCollegamento === 'collegateDivisorio';
      switch (link.latocollegato) {
        case 'lato_retro':
          // verticale: solo collegateDivisorio (combinate già in drawConfigurazione)
          if (
            isDiv &&
            !hasUniteOnRetro &&
            this.deveAllontanareDaDivisorio(cella, link) &&
            topThis > topOther + 0.5
          ) {
            dOy = Math.max(dOy, o.dOy + delta);
          }
          break;
        case 'lato_fronte':
        case 'lato_sn':
        case 'lato_ds':
          break;
        default:
          break;
      }
    });

    const out = { dOx, dOy };
    memo.set(cella.id, out);
    return out;
  }

  /**
   * Celle unite sul diagramma sono affiancate (lati a contatto senza overlap).
   * In 3D va spostata la più corta sul lato di contatto così i pannelli uniti si sovrappongono;
   * se le lunghezze sono uguali, una sola (quella con !latocombinato).
   */
  deveSovrapporreLatoUnite(cella: any, lato: string): boolean {
    const links = (cella?.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'unite' &&
        x.latocollegato === lato,
    );
    if (!links.length) {
      return false;
    }
    return links.some((l: any) => {
      const other = (this.configurazioneCelle?.elencoCelle || []).find(
        (c: any) => c.id == l.cellaCollegataId,
      );
      if (!other) {
        return !l.latocombinato;
      }
      const dimThis =
        lato === 'lato_sn' || lato === 'lato_ds'
          ? cella.ingombroY || 0
          : cella.ingombroX || 0;
      const dimOther =
        lato === 'lato_sn' || lato === 'lato_ds'
          ? other.ingombroY || 0
          : other.ingombroX || 0;
      if (dimThis < dimOther) {
        return true;
      }
      if (dimThis > dimOther) {
        return false;
      }
      // uguali: una sola cella — quella con !latocombinato.
      // Se entrambe !latocombinato, evita doppio sp+3: muove solo questa se id < other.
      if (!l.latocombinato) {
        const otherLink = (other.celleCollegate || []).find(
          (x: any) =>
            x.attivo &&
            x.tipoCollegamento === 'unite' &&
            x.cellaCollegataId == cella.id,
        );
        if (otherLink && !otherLink.latocombinato) {
          return String(cella.id) < String(other.id);
        }
        return true;
      }
      return false;
    });
  }

  public drawConfigurazione():any{

    let codiciAll:any={spessoriCelle:[],codiciCelle:[],codiciPorteConf:[],tipoPorteConf:[],pavimentiCelle:[]};
    this.clear();
    let x:number=0;
    let z:number=0;
    let spessoreP=0;
   
    this.configurazioneCelle.angoliDaCanc=[];
    this.configurazioneCelle.calcAngoliDaCanc=true;

    // 3 passate globali sui compensatori divisorio (parziali → pieni → opposti),
    // tenute in mS.compensoDivisorioReg e riusate da getObj2 / insertPannelliLatoConPorte2
    this.configurazioneCelle._compensoDivisorioPrepared = false;
    this.mS.prepareCompensoDivisorioRegistry(this.configurazioneCelle);

    // Ordine disegno: dall'alto a sinistra (offsetY crescente, poi offsetX).
    // Una volta disegnata una cella i suoi lati non si ritoccano più.
    const celleOrdinate = [...(this.configurazioneCelle.elencoCelle || [])].sort(
      (a: any, b: any) => {
        const dy = (a.offsetY3d || 0) - (b.offsetY3d || 0);
        if (Math.abs(dy) > 0.5) {
          return dy;
        }
        return (a.offsetX3d || 0) - (b.offsetX3d || 0);
      },
    );
    this.configurazioneCelle._celleDisegnateIds = new Set<any>();

    celleOrdinate.forEach((c: any) => {
      this.mS.cellaDati = c;
      this.drawCella(x, z);
    });
    this.configurazioneCelle.calcAngoliDaCanc = false;

    celleOrdinate.forEach((c: any, ind: number) => {
      this.mS.cellaDati = c;

      // Baseline: solo offset diagramma (larghezza/altezza).
      x = -(c.offsetY3d || 0);
      z = c.offsetX3d || 0;

      // Divisorio / combinate: crea il gap di sp+3 SOLO se il vicino è già disegnato.
      // Disegno dall'alto: le celle già fatte non si ritoccano; chi viene dopo si allontana.
      // (es. A–B unite, poi C con divisorio su B → A e B restano; C crea il gap)
      // Se B ha unite perpendicolare ad A, non spostare B: altrimenti A (già disegnata)
      // resta e B scorre di sp+3 → disallineamento della cella unita.
      const delta = (c.spessore || 0) + 3;
      const drawn = this.configurazioneCelle._celleDisegnateIds as Set<any> | undefined;
      const linksGap = (c.celleCollegate || []).filter((l: any) => {
        if (
          !l.attivo ||
          (l.tipoCollegamento !== 'collegateDivisorio' &&
            l.tipoCollegamento !== 'combinate') ||
          !drawn?.has(l.cellaCollegataId)
        ) {
          return false;
        }
        if (
          l.tipoCollegamento === 'collegateDivisorio' &&
          this.hasUnitePerpendicolareAlLato(c, l.latocollegato)
        ) {
          return false;
        }
        return true;
      });
      linksGap.forEach((link: any) => {
        // verso di allontanamento = opposto al lato di contatto
        switch (link.latocollegato) {
          case 'lato_ds':
            z -= delta;
            break;
          case 'lato_sn':
            z += delta;
            break;
          case 'lato_fronte':
            x += delta;
            break;
          case 'lato_retro':
            x -= delta;
            break;
          default:
            break;
        }
      });

      console.log('[drawCella]', {
        cellaId: c.id,
        x,
        y: z,
        offsetX3d: c.offsetX3d || 0,
        offsetY3d: c.offsetY3d || 0,
        delta,
        linksGap: linksGap.map((l: any) => ({
          tipo: l.tipoCollegamento,
          lato: l.latocollegato,
          other: l.cellaCollegataId,
          latocombinato: !!l.latocombinato,
        })),
      });

      this.mS.cellaDati.numCoprifilo=0;
        
      if(ind<celleOrdinate.length-1){
        this.mS.cellaDati.succW=celleOrdinate[ind+1].ingombroX;
        this.mS.cellaDati.succD=celleOrdinate[ind+1].ingombroY; 
      }
    
      spessoreP=this.mS.cellaDati.spessore;

   
      if(this.mS.cellaDati.isMiniCella){
        this.drawCella(x,z);
      } else {
      
        
        if(ind==0){
          let cods=this.drawCella(x,z);
          cods=[...cods,...this.mS.getChiaveAElle(this.mS.cellaDati)]; 
          codiciAll['codiciCelle'].push(cods); 
        } else {
          codiciAll['codiciCelle'].push(this.drawCella(x,z));
        }
        codiciAll['spessoriCelle'].push(this.mS.cellaDati.spessore);
        codiciAll['pavimentiCelle'].push(this.mS.cellaDati.pavimenti);
        codiciAll['codiciPorteConf'].push([]);
        codiciAll['tipoPorteConf'].push([]);
        // aggiunge i codici per valvola di compensazione
        let volume=0;
        let qty=1;
        let codice='';
        if(c.ingombroX && c.ingombroY && c.altezza){
          volume= Math.round(c.ingombroX*c.ingombroY*c.altezza/1000000 * 100) / 100;
        }
        if(c.valvolaCompensazione){
          if(c.spessore==10 || c.spessore==13  ){
              if(volume>75){
                qty=2;
              }
              codice='M2157931';
              
          } else {
            if(volume>75){
                qty=2;
            }
            codice='M2157932';
          }

          let isPres=false;
          codiciAll['codiciCelle'][ind].forEach((z:any,indTem:number)=>{
            if(z.codice==codice){
              isPres=true;
              codiciAll['codiciCelle'][ind][indTem].qty+=qty;
            }
          });
          if(!isPres){
            codiciAll['codiciCelle'][ind].push({
              art_comp:codice,
              qty:qty
            });
          } 
        }
        
        // aggiunge i dati per le tende a strisce
        c.elencoPorte.forEach((p:any)=>{
          if(p.strisceporta){
            let codice='strisceporta';
            let portaLabel=p.modelliPortaOptions.filter((m:any)=> m.value==p.modelloPorta)[0].luceNetta;
            this.mS.codiciPertendeAStrisce.forEach((m:any)=>{
              
                if(portaLabel.indexOf(m.luce_netta)>=0){
                  codice=m.nr;
                }
             
            });
          
            let isPres=false;
            codiciAll['codiciCelle'][ind].forEach((z:any,indTemp:number)=>{
              if(z.codice==codice){
                isPres=true;
                codiciAll['codiciCelle'][ind][indTemp].qty++;
              }
            });
            if(!isPres){
              codiciAll['codiciCelle'][ind].push({
                art_comp:codice,
                qty:1
              });
            } 
          }
        });

        
        // aggiunge i dati per il set accopp
        let setAccopp=false;
        let spessore2=6;
        let ingombro=0;
        c.celleCollegate.filter((x:any)=>x.attivo).forEach((coll:any)=>{
          if(coll.tipoCollegamento=='combinate'){
            if(coll.latocombinato){
            setAccopp=true;
            if(coll.latocollegato=='lato_fronte' || coll.latocollegato=='lato_retro' ){
              ingombro=c.ingombroX;
            } else {
              ingombro=c.ingombroY;
            }
            spessore2=this.configurazioneCelle.elencoCelle.filter((x:any)=>x.id==coll.cellaCollegataId)[0].spessore;
            } 
          }
        });
        if(setAccopp){
          if((c.spessore==6 && spessore2==10) || (c.spessore==10 && spessore2==6) ){
            // UNA DA 10 UNA DA 6
            // MS046868	misa	SET ACCOPP.VERT.10/6 KL R7 200
            // MS046869	misa	SET ACCOPP.VERT.10/6 KL R7 240
            // MS046872	misa	SET ACCOPP.VERT.10/6 KL R7 280
            // MS046873	misa	SET ACCOPP.VERT.10/6 KL R7 320
            switch(c.altezza){
              case 200:
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046868',2); 
                break;
              case 220:
              case 240:
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046869',2); 
                break;
              case 260:
              case 280:
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046872',2); 
                break;
              case 300:
              case 320:
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046873',2); 
                break;
            } 
            // MS046874	misa	SET ACCOPP.ORIZ.10/6 KL R7 200
            // MS046875	misa	SET ACCOPP.ORIZ.10/6 KL R7 240
            // MS046876	misa	SET ACCOPP.ORIZ.10/6 KL R7 280
            // MS046877	misa	SET ACCOPP.ORIZ.10/6 KL R7 320 
          
            if(ingombro<=200){
               this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046874',1); 
            }
             if(ingombro>200 && ingombro<=240){
               this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046875',1); 
            }
            if(ingombro>240 && ingombro<=280){
               this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046876',1); 
            }
            if(ingombro>280){
               this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046877',1); 
            } 
        
          } else {
            if(c.spessore==10 && spessore2==10){
              // MS046888	misa	SET ACCOPP.VERT.10/10 KLR7 200
              // MS046889	misa	SET ACCOPP.VERT.10/10 KLR7 240
              // MS046890	misa	SET ACCOPP.VERT.10/10 KLR7 280
              // MS046891	misa	SET ACCOPP.VERT.10/10 KLR7 320
              switch(c.altezza){
                case 200:
                  this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046888',2); 
                  break;
                case 220:
                case 240:
                  this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046889',2); 
                  break;
                case 260:
                case 280:
                  this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046890',2); 
                  break;
                case 300:
                case 320:
                  this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046891',2); 
                  break;
              } 
              // MS046892	misa	SET ACCOPP.ORIZ.10/10 KLR7 200
              // MS046893	misa	SET ACCOPP.ORIZ.10/10 KLR7 240
              // MS046894	misa	SET ACCOPPIAMENTO ORIZZONTALE 10/10 KLR7 280
              // MS046895	misa	SET ACCOPPIAMENTO ORIZZONTALE 10/10 KLR7 320
              if(ingombro<=200){
               this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046892',1); 
              }
              if(ingombro>200 && ingombro<=240){
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046893',1); 
              }
              if(ingombro>240 && ingombro<=280){
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046894',1); 
              }
              if(ingombro>280){
                this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046895',1); 
              } 
              this.pushOrAdd(codiciAll['codiciCelle'][ind],'MS046895',1); 
            }
          }
        }
      }
    
    });
   
    return codiciAll;

  }
  pushOrAdd(ele:any,codice:string,qty:number){
    let isPres=false;
    ele.forEach((z:any,ind:number)=>{
      if(z.art_comp==codice){
        isPres=true;
        ele[ind].qty+=qty;
      }
    });
    if(!isPres){
      ele.push({
        art_comp:codice,
        qty:qty
      });
    } 
  }

  fillPanel(x:number,y:number,z:number,color:any=null){
    const geometry = new THREE.BoxGeometry( x, y, z ); 
    let ccolor=color;
    if(!ccolor){
      ccolor=this.mS.pannelloAzzurroHex;
    }
    const material = new THREE.MeshBasicMaterial( {
      transparent: true,
      opacity: 0.4,
      color: ccolor} ); 
    return new THREE.Mesh( geometry, material ); 
    
  }

  public drawCella(x:number,z:number):any{
     this.configurazioneCelle.spigoli=[];
     this.latoAngolare = (this.mS.cellaDati?.spessore || 0) + 1.5;
     if((this.mS.cellaDati)&&(this.mS.cellaDati.ingombroX>0)&&(this.mS.cellaDati.altezza>0)&&(this.mS.cellaDati.ingombroY>0)){
      this.mS.objCella={
            w:this.mS.cellaDati.ingombroY,
            h:this.mS.cellaDati.altezza,
            d:this.mS.cellaDati.ingombroX,
            spessore:this.mS.cellaDati.spessore,
            cappucci:[],
            angolari:[]
          };
      this.group = new THREE.Group();
      this.mS.getObj(this.configurazioneCelle);
      if(this.configurazioneCelle.calcAngoliDaCanc){
        return;
      }
      // Cella disegnata: da qui i suoi lati non si ritoccano più.
      if (this.configurazioneCelle._celleDisegnateIds && this.mS.cellaDati?.id != null) {
        this.configurazioneCelle._celleDisegnateIds.add(this.mS.cellaDati.id);
      }

      if(this.mS.cellaDati.vespaio){
        this.disegnaVespaio();
      }

      this.disegnaTravi();

       this.disegnaPannelli(Math.abs(z),Math.abs(x));
      
      if(this.mS.cellaDati.pavimenti){
        this.disegnaAngolariPavSof3(0);
      }
      this.disegnaAngolariPavSof3(-1*this.mS.objCella.h);
      this.disegnaAngolariVert2();

      
      this.group.translateX(x-this.mS.objCella.w);
      this.group.translateZ(z);
      this.scene.add( this.group );

      let codici:any[]=[];
      let lbp:any[]=this.listAllPannelli(this.mS.objCella); 
      
 

      codici=[...codici,...this.mS.getSetProfiloDivisorio(this.mS.cellaDati)];
      codici=[...codici,...this.mS.getFastFit_SupportoSoffitto(this.mS.objCella)];
      codici=[...codici,...this.mS.getTappi2(lbp,this.mS.cellaDati)];
      
      codici=[...codici,...this.mS.getCopriFilo(lbp)];
      codici=[...codici,...this.mS.getLaterali(this.mS.objCella)];

      codici=[...codici,...this.mS.getPavimento(this.mS.objCella)];
      
      codici=[...codici,...this.mS.getTravi(this.mS.objCella)];
      codici=[...codici,...this.mS.getFastFit(this.mS.objCella)];
      codici=[...codici,...this.mS.getSigillante(this.mS.objCella)];
      
      if(this.mS.cellaDati.vespaio){
        codici=[...codici,...this.mS.getVespaio(this.mS.objCella)];
      }

      codici=[...codici,...this.mS.getAngolari(this.mS.objCella,this.configurazioneCelle)];

      if(!this.mS.cellaDati.pavimenti){
        codici=[...codici,...this.mS.getAngolariU(this.mS.objCella)];
      }
      
      codici=[...codici,...this.mS.getCappucci(this.mS.objCella,this.configurazioneCelle)];
      codici=[...codici,...this.mS.getPorte(this.mS.cellaDati)];
      return codici;
    }
  }

  listAllPannelli(obj:any){
    let ls:any[]=[];
    this.mS.objDivisori.forEach((divisore:any)=>{
      divisore.pannelli.forEach((p:any)=>{
          ls.push(p);
      });
    });

    obj.objFronte.pannelli.forEach((p:any)=>{
      ls.push(p);
    });
    obj.objRetro.pannelli.forEach((p:any)=>{
      ls.push(p);
    });
    obj.objPavimento.pannelli.forEach((p:any)=>{
      ls.push(p);
    });
    obj.objSoffitto.pannelli.forEach((p:any)=>{
      ls.push(p);
    });
    obj.objLatSin.pannelli.forEach((p:any)=>{
      ls.push(p);
    });
    obj.objLatDs.pannelli.forEach((p:any)=>{
      ls.push(p);
    }); 

    
    return ls;
  }
  

public disegnaPdf(what:string,paginaW:number,cx:number,cy:number){
    let label:string='';
    let misura:any={
      cx:cx,
      cy:cy
    };
    switch (what){
      case 'soffitto':
        label=this.lang.el('Piano soffitto');
        break;
      case 'pavimento':
        label=this.lang.el('Piano pavimento');
        break;
      case 'pareti':
        label=this.lang.el('Piano pareti');
        break;
    }
    
    this.pdf.setFont("courier");
    this.pdf.setFontSize(12).setFont(undefined, 'normal').text(label,paginaW/2-this.pdf.getTextWidth(label),cy*this.pdfProp/2,{
      align: 'left'
    });
 
    this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
      this.mS.cellaDati=c;
      if(ind==0){
        misura.larg=c.ingombroX;
        misura.alt=c.ingombroY;
      }
      if((this.mS.cellaDati)&&(this.mS.cellaDati.ingombroX>0)&&(this.mS.cellaDati.altezza>0)&&(this.mS.cellaDati.ingombroY>0)){
        this.mS.objCella={
              w:this.mS.cellaDati.ingombroY,
              h:this.mS.cellaDati.altezza,
              d:this.mS.cellaDati.ingombroX,
              spessore:this.mS.cellaDati.spessore,
              cappucci:[],
              angolari:[]
            };

        this.mS.getObj(this.configurazioneCelle);
        switch (what){
          case 'soffitto':
            this.disegnaPdfCellaSoffitto(cx,cy);
            break;
          case 'pavimento':
            this.disegnaPdfCellaPavimento(cx,cy);
            break;
          case 'pareti':
            this.disegnaPdfCellaPareti(cx,cy);
            break;
        }
        if(ind<this.configurazioneCelle.elencoCelle.length-1){
          if(c.lato_raccordo=='lato_sn' || c.lato_raccordo=='lato_ds'){
                cx+=c.ingombroX;
                misura.larg+=c.ingombroX;
              }
              if(c.lato_raccordo=='lato_fronte' || c.lato_raccordo=='lato_retro'){
                cy+=c.ingombroY;
                misura.alt+=c.ingombroY;
              }
        }
      }


    });
    this.drawMisuraSinistra(misura.cx*this.pdfProp,misura.cy*this.pdfProp,this.pdfProp,1,misura.larg,misura.alt);
    this.drawMisureSotto(misura.cx*this.pdfProp,misura.cy*this.pdfProp,this.pdfProp,1,misura.larg,misura.alt);
    
}



public creaPDF(what:string,formato:string){
  
  let cx=10;
  let cy=10;
  let maxW=0;
  let maxH=0;
 
  
  
  this.pdf= new JSPDF.jsPDF('l','mm',formato);
  let paginaW=this.pdf.internal.pageSize.getWidth();
  let paginaH=this.pdf.internal.pageSize.getHeight();

  this.pdf.setLineWidth(.05);
  this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
    // cella singola
    if(ind==0 ){
      maxW+=c.ingombroX;
      maxH+=c.ingombroY;
    } 
    if(ind>0 && (c.lato_raccordo_prec=='lato_fronte' || c.lato_raccordo_prec=='lato_retro')){
      maxH+=c.ingombroY;
    }
    if(ind>0 && (c.lato_raccordo_prec=='lato_sn' || c.lato_raccordo_prec=='lato_ds')){
      maxW+=c.ingombroX;
    }



  });
  this.pdfProp=paginaW/maxW*0.6;
  if(paginaW/maxW>paginaH/maxH){
    this.pdfProp=paginaH/maxH*0.6;
  }
 
  cy=(paginaH/this.pdfProp-maxH)/2;
  cx=(paginaW/this.pdfProp-maxW)/2;
  
  if(what=='all'){
    paginaW=paginaW/2;
    paginaH=paginaH/2;  
    this.pdfProp=paginaW/maxW*0.6;
    if(paginaW/maxW>paginaH/maxH){
      this.pdfProp=paginaH/maxH*0.6;
    }
    cy=(paginaH/this.pdfProp-maxH)/2;
    cx=(paginaW/this.pdfProp-maxW)/2;
    this.disegnaPdf('soffitto',paginaW,cx,cy);
    
    cy=(paginaH/this.pdfProp-maxH)/2;
    cx+=(paginaW/this.pdfProp-maxW)/2+maxW;
    this.disegnaPdf('pareti',paginaW,cx,cy);
    
    cx=(paginaW/this.pdfProp-maxW)/2;
    cy+=paginaH/this.pdfProp;
    this.disegnaPdf('pavimento',paginaW,cx,cy);

  }

  if(what=='soffitto'){
    this.disegnaPdf('soffitto',paginaW,cx,cy);
  }
  if(what=='pavimento'){
    this.disegnaPdf('pavimento',paginaW,cx,cy);
  }

  if(what=='pareti'){
    this.disegnaPdf('pareti',paginaW,cx,cy);
  }

  this.pdf.save(this.lang.el('Tavole disegni')+'.pdf');

}

pdfAngoloSS(context:any,cx:number,cy:number,raggio:number){
  let x1=cx*this.pdfProp;
  let y1=cy*this.pdfProp;
  
  context.beginPath();
  context.arc(x1, y1, raggio*this.pdfProp,-1*Math.PI,-1*Math.PI/2,false);
  context.stroke();
  this.pdf.line(x1, y1,x1-raggio*this.pdfProp,y1);
  this.pdf.line(x1, y1,x1,y1+raggio*this.pdfProp);

}

pdfAngoloSD(context:any,cx:number,cy:number,raggio:number){
  context.beginPath();
  context.arc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,-1*Math.PI/2,0,false);
  context.stroke();
}


pdfAngoloID(context:any,cx:number,cy:number,raggio:number){
  context.beginPath();
  context.arc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,0,Math.PI/2,false);
  context.stroke();
}

pdfAngoloIS(context:any,cx:number,cy:number,raggio:number){
  context.beginPath();
  context.arc(cx*this.pdfProp, cy*this.pdfProp, raggio*this.pdfProp,Math.PI/2,Math.PI,false);
  context.stroke();
}


pdfPannello(x:number,y:number,w:number,h:number,testo:string='',angolo:number=0){
  this.pdf.rect(x*this.pdfProp,y*this.pdfProp,w*this.pdfProp,h*this.pdfProp);
  if(testo!=''){  
    if(angolo==0){
      this.pdf.setFontSize(8).setFont(undefined, 'normal').text(testo,
        (x+w/2)*this.pdfProp+this.pdf.getTextWidth(testo)/2,
        (y+h/2)*this.pdfProp,{
            align: 'left',
            angle:angolo
      }); 
    } else {
      this.pdf.setFontSize(8).setFont(undefined, 'normal').text(testo,
        (x+w/2)*this.pdfProp,
        (y+h/2)*this.pdfProp+this.pdf.getTextWidth(testo)/2,{
            align: 'left',
            angle:angolo
      }); 
    }
    
    
  }
  
  
}

disegnaPdfCellaPareti(cx:number,cy:number){
  var context = this.pdf.context2d;
  context.lineWidth =.1;
 
  
  let dim=this.pdf.getTextDimensions('1200');
  let factor=this.pdfProp;
  let primoPannSpessore=0;
  let ultimoPannSpessore=0;
  let curx=cx*factor;
  let cury=cy*factor;
  if(this.mS.cellaDati.lato_raccordo_prec!='lato_fronte' && this.mS.cellaDati.lato_raccordo!='lato_retro'){
      this.mS.objRetro.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any,ind:number) => {
      if(ind==0){
        primoPannSpessore=p.d;
      }
      ultimoPannSpessore=p.d;
      this.pdf.rect(curx,cury,p.w*factor,-p.d*factor);
      this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-this.pdf.getTextWidth((p.w*10).toString())/2,cury-dim.h,{
          align: 'left',
      });
      if(p.porta){       
        if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx,cury-1*p.d*factor,p.w*factor,-1*p.d*factor/2);
              this.pdf.rect(curx+p.w*factor-manigliaw,cury-1*p.d*factor/2*3,manigliaw,-manigliah);
              context.beginPath();
              context.arc(curx, cury-1*p.d*factor, p.w*factor,-1*Math.PI/2,0,false);
              context.stroke();
              this.pdf.line(curx,cury-1*p.d*factor,curx,cury-1*p.d*factor-p.w*factor);
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx,cury-1*p.d*factor,p.w*factor,-1*p.d*factor/2);
              this.pdf.rect(curx,cury-1*p.d*factor/2*3,manigliaw,-manigliah);
              context.beginPath();
              context.arc(curx+p.w*factor, cury-1*p.d*factor, p.w*factor,-1*Math.PI,-1*Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx+p.w*factor,cury-1*p.d*factor,curx+p.w*factor,cury-1*p.d*factor-p.w*factor);
          }
        }
        
      }
      curx+=p.w*factor;
    });
  }
  curx=cx*factor;
  cury=cy*factor+this.mS.objCella.w*factor;
  if(this.mS.cellaDati.lato_raccordo_prec!='lato_retro' && this.mS.cellaDati.lato_raccordo!='lato_fronte'){
    this.mS.objFronte.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any) => {
      this.pdf.rect(curx,cury,p.w*factor,p.d*factor);
      this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-this.pdf.getTextWidth((p.w*10).toString())/2,cury+dim.h*1.5,{
          align: 'left',
      });
      if(p.porta){
            if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx,cury+p.d*factor,p.w*factor,p.d*factor/2);
              this.pdf.rect(curx,cury+1*p.d*factor/2*3,manigliaw,manigliah);
              context.beginPath();
              context.arc(curx+p.w*factor, cury+1*p.d*factor, p.w*factor,Math.PI/2,Math.PI,false);
              context.stroke();
              this.pdf.line(curx+p.w*factor,cury+p.d*factor,curx+p.w*factor,cury+1*p.d*factor+p.w*factor);
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/20;
              this.pdf.rect(curx,cury+p.d*factor,p.w*factor,p.d*factor/2);
              this.pdf.rect(curx+p.w*factor-manigliaw,cury+p.d*factor/2*3,manigliaw,manigliah);
              context.beginPath();
              context.arc(curx, cury+p.d*factor, p.w*factor,0,Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx,cury+p.d*factor,curx,cury+p.d*factor+p.w*factor);
          }
        }
      }
      curx+=p.w*factor;
    });
  }
  curx=cx*factor;
  cury=cy*factor;
  if(this.mS.cellaDati.lato_raccordo_prec!='lato_ds' && this.mS.cellaDati.lato_raccordo!='lato_sn'){
    this.mS.objLatSin.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any) => {
      this.pdf.rect(curx,cury,-1*p.d*factor,p.w*factor);
      this.pdf.text((p.w*10).toString(),curx-dim.h,cury+p.w*factor/2,{
          align: 'left',
          angle:90
      });
      if(p.porta){
        if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx-p.d*factor,cury,-p.d*factor/2,p.w*factor);
              this.pdf.rect(curx-p.d*factor-p.d*factor/2,cury,-manigliah,manigliaw);
              context.beginPath();
              context.arc(curx-p.d*factor, cury+p.w*factor, p.w*factor,-1*Math.PI,-1*Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx-p.d*factor,cury+p.w*factor,curx-p.w*factor-p.d*factor,cury+p.w*factor);
            } else {
                let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx-p.d*factor,cury,-p.d*factor/2,p.w*factor);
              this.pdf.rect(curx-p.d*factor-p.d*factor/2,cury+p.w*factor,-manigliah,-manigliaw);
              context.beginPath();
              context.arc(curx-p.d*factor, cury, p.w*factor,Math.PI/2,Math.PI,false);
              context.stroke();
              this.pdf.line(curx-p.d*factor,cury,curx-p.w*factor-p.d*factor,cury);
          }
        }
      }
      cury+=p.w*factor;
    });
  }
  
  curx=cx*factor+this.mS.objCella.d*factor;
  cury=cy*factor;
  if(this.mS.cellaDati.lato_raccordo_prec!='lato_sn'  && this.mS.cellaDati.lato_raccordo!='lato_ds'){
    this.mS.objLatDs.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any) => {
      this.pdf.rect(curx,cury,p.d*factor,p.w*factor);
      this.pdf.text((p.w*10).toString(),curx+dim.h*1.5,cury+p.w*factor/2,{
          align: 'left',
          angle:90
      });
        if(p.porta){
        if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx+p.d*factor,cury,p.d*factor/2,p.w*factor);
              this.pdf.rect(curx+p.d*factor+p.d*factor/2,cury+p.w*factor,manigliah,-manigliaw);
              context.beginPath();
              context.arc(curx+p.d*factor, cury, p.w*factor,0,Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx,cury,curx+p.w*factor,cury);

              
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx+p.d*factor,cury,p.d*factor/2,p.w*factor);
              this.pdf.rect(curx+p.d*factor+p.d*factor/2,cury,manigliah,manigliaw);
              context.beginPath();
              context.arc(curx+p.d*factor, cury+p.w*factor, p.w*factor,-1*Math.PI/2,0,false);
              context.stroke();
              this.pdf.line(curx,cury+p.w*factor,curx+p.w*factor,cury+p.w*factor);
          }
        }
      }
      cury+=p.w*factor;
    });
  }
 
  curx=cx;
  cury=cy;
  if(primoPannSpessore==0){
    primoPannSpessore= this.mS.objCella.spessore;
    ultimoPannSpessore= this.mS.objCella.spessore;
  }

  
  if(this.mS.disegnaAngolo('w',this.configurazioneCelle)){
    this.pdfAngoloSS(context,curx, cury, primoPannSpessore);
  }
  if(this.mS.disegnaAngolo('wd',this.configurazioneCelle)){
    this.pdfAngoloSD(context,curx+this.mS.objCella.d, cury, ultimoPannSpessore);
  }
  if(this.mS.disegnaAngolo('d',this.configurazioneCelle)){
     this.pdfAngoloID(context,curx+this.mS.objCella.d, cury+this.mS.objCella.w, this.mS.objCella.spessore);
  }
  if(this.mS.disegnaAngolo('0',this.configurazioneCelle)){
    this.pdfAngoloIS(context,curx, cury+this.mS.objCella.w, this.mS.objCella.spessore);
  }
}

disegnaPdfCellaPavimento(cx:number,cy:number){
  var context = this.pdf.context2d;
  context.lineWidth =.1;
  let factor=this.pdfProp;

  let ccx=cx;
  let ccy=cy;
  let last=0;
    this.mS.objPavimento.pannelli.filter((x:any)=>x.side=='pavimento').forEach((p:any) => {    
      if(!this.mS.cellaDati.ruotaPavimento){
      if(p.z==0){
        ccy+=last;
       }
      this.pdfPannello(ccx+p.z,ccy,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),0);
      last=p.w;
    }else {
      if(p.z==0){
        ccx+=last;
       }
      this.pdfPannello(ccx,ccy+p.z,p.w,p.h,(p.w*10).toString()+'x'+(p.h*10).toString(),90);
      last=p.w;
    }
    });
    ccx=cx;
    ccy=cy;

    //lato fronte
    this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
    //lato ds
    this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);
    //lato sn
    this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
    //lato retro
    this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);


    this.pdfAngoloSS(context,ccx*factor, ccy*factor, this.mS.objCella.spessore*factor);
    this.pdfAngoloSD(context,ccx*factor+this.mS.objCella.d*factor, ccy*factor, this.mS.objCella.spessore*factor);
    this.pdfAngoloID(context,ccx*factor+this.mS.objCella.d*factor, ccy*factor+this.mS.objCella.w*factor, this.mS.objCella.spessore*factor);
    this.pdfAngoloIS(context,ccx*factor, ccy*factor+this.mS.objCella.w*factor, this.mS.objCella.spessore*factor);

  
}

disegnaPdfCellaSoffitto(cx:number,cy:number){
    var context = this.pdf.context2d;
    context.lineWidth =.1;
    let factor=this.pdfProp;

    let ccx=cx;
    let ccy=cy;
    let last=0;
    this.mS.objSoffitto.pannelli.filter((x:any)=>x.side=='soffitto').forEach((p:any) => {    
      if(!this.mS.cellaDati.ruotasoffitto){
      if(p.z==0){
        ccy+=last;
       }
      this.pdfPannello(ccx+p.z,ccy,p.h,p.w,(p.w*10).toString()+'x'+(p.h*10).toString(),0);
      last=p.w;
    }else {
      if(p.z==0){
        ccx+=last;
       }
      this.pdfPannello(ccx,ccy+p.z,p.w,p.h,(p.w*10).toString()+'x'+(p.h*10).toString(),90);
      last=p.w;
    }
    });
    ccx=cx;
    ccy=cy;

    //lato fronte
    this.pdfPannello(ccx,ccy,this.mS.objCella.d,-1*this.mS.objCella.spessore);
    //lato ds
    this.pdfPannello(ccx+this.mS.objCella.d,ccy,this.mS.objCella.spessore,this.mS.objCella.w);
    //lato sn
    this.pdfPannello(ccx,ccy,-1*this.mS.objCella.spessore,this.mS.objCella.w);
    //lato retro
    this.pdfPannello(ccx,ccy+this.mS.objCella.w,this.mS.objCella.d,this.mS.objCella.spessore);


    this.pdfAngoloSS(context,ccx*factor, ccy*factor, this.mS.objCella.spessore*factor);
    this.pdfAngoloSD(context,ccx*factor+this.mS.objCella.d*factor, ccy*factor, this.mS.objCella.spessore*factor);
    this.pdfAngoloID(context,ccx*factor+this.mS.objCella.d*factor, ccy*factor+this.mS.objCella.w*factor, this.mS.objCella.spessore*factor);
    this.pdfAngoloIS(context,ccx*factor, ccy*factor+this.mS.objCella.w*factor, this.mS.objCella.spessore*factor);



}

// PDF 

public drawTavolaPdf(
  factor:number,factorY:number,what:string,label:string,pdfW:number,pdfX:number,pdfY:number,
  larghComplessiva:number,lunghComplessiva:number,formato:string){
  if(this.configurazioneCelle.elencoCelle.length==1){
    this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
    
      this.mS.cellaDati=c;
      if((this.mS.cellaDati)&&(this.mS.cellaDati.ingombroX>0)&&(this.mS.cellaDati.altezza>0)&&(this.mS.cellaDati.ingombroY>0)){
        this.mS.objCella={
              w:this.mS.cellaDati.ingombroX,
              h:this.mS.cellaDati.altezza,
              d:this.mS.cellaDati.ingombroY,
              spessore:this.mS.cellaDati.spessore,
              cappucci:[],
              angolari:[]
            };

        this.mS.getObj(this.configurazioneCelle);
        
        this.drawPdf(factor,factorY,pdfX,pdfY,pdfW,label,what,this.mS.objCella.w,this.mS.objCella.d,formato);
       
      }
    });

  } else {
    
      this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
    
        this.mS.cellaDati=c;
        if((this.mS.cellaDati)&&(this.mS.cellaDati.ingombroX>0)&&(this.mS.cellaDati.altezza>0)&&(this.mS.cellaDati.ingombroY>0)){
          this.mS.objCella={
                w:this.mS.cellaDati.ingombroX,
                h:this.mS.cellaDati.altezza,
                d:this.mS.cellaDati.ingombroY,
                spessore:this.mS.cellaDati.spessore,
                cappucci:[],
                angolari:[]
              };

          this.mS.getObj(this.configurazioneCelle);
          

   //   factor=pdfW/this.mS.objCella.w;
   //   factorY=factor;
    factorY=factor;
    if(ind==this.cellaperLabel){
      this.drawPdf(factor,factorY,c.cx*factor+pdfX,c.cy*factor+pdfY,
        this.mS.objCella.w*factor,label,what,lunghComplessiva,larghComplessiva,formato); 
    } else {
      this.drawPdf(factor,factorY,c.cx*factor+pdfX,c.cy*factor+pdfY,this.mS.objCella.w*factor,'',what,0,0,formato); // senza titolo celle successive
    }
  
      
    }
  });
  }
  
  
}

public tavolaPdf(what:string,formato:string){
  let pdfW:number=0;
  let pdfH:number=0;
  let pdfX:number=0;

  this.creaPDF(what,formato);
  return;

  let label:string='';
  let filename:string='';
  if( formato=='a3') {
    this.pdf= new JSPDF.jsPDF('l','mm',formato);
  } else {
    this.pdf= new JSPDF.jsPDF('p','mm',formato);
  }
  this.pdf.setLineWidth(.05);
  let paginaW=this.pdf.internal.pageSize.getWidth();
  let paginaH=this.pdf.internal.pageSize.getHeight();
  let pdfY:number=Math.round(paginaH/7); // margine iniziale
  let lunghComplessiva=this.configurazioneCelle.elencoCelle[0].ingombroY;
  let larghComplessiva=this.configurazioneCelle.elencoCelle[0].ingombroX;

  if(what=='all'){
    paginaW=paginaW/4;
    paginaH=paginaH/3;
    pdfW=paginaW*0.8;
    pdfH=paginaH*0.8;
  } else {
    pdfW=paginaW/2;
    pdfH=paginaH/2;
  }

  

  pdfX=Math.round((paginaW-pdfW)/2);


  let factor:number=pdfW/this.configurazioneCelle.elencoCelle[0].ingombroX;
  let factorY:number=pdfH/this.configurazioneCelle.elencoCelle[0].ingombroY;
  if(factor>factorY){
    factor=factorY;
    pdfW=factorY*this.configurazioneCelle.elencoCelle[0].ingombroX;
    pdfX=Math.round((paginaW-pdfW)/2);
  }




  if(this.configurazioneCelle.elencoCelle.length>1){
    
  
    // elaboro x e y per ogni cella
    // dalle x e y prendo la lungh e altezza complessiva
    this.configurazioneCelle.elencoCelle[0].cx=0;
    this.configurazioneCelle.elencoCelle[0].cy=0;
   
    for(let j=1;j<this.configurazioneCelle.elencoCelle.length;j++){
      if(this.configurazioneCelle.elencoCelle[j].lato_raccordo_prec=='lato_fronte'){
        this.configurazioneCelle.elencoCelle[j].cy= this.configurazioneCelle.elencoCelle[j-1].cy+this.configurazioneCelle.elencoCelle[j-1].ingombroX;
        this.configurazioneCelle.elencoCelle[j].cx= this.configurazioneCelle.elencoCelle[j-1].cx;
        lunghComplessiva+=this.configurazioneCelle.elencoCelle[j].ingombroX;
      }
      if(this.configurazioneCelle.elencoCelle[j].lato_raccordo_prec=='lato_retro'){
        this.configurazioneCelle.elencoCelle[j].cy= this.configurazioneCelle.elencoCelle[j-1].cy-this.configurazioneCelle.elencoCelle[j].ingombroX;
        this.configurazioneCelle.elencoCelle[j].cx= this.configurazioneCelle.elencoCelle[j-1].cx;
        lunghComplessiva+=this.configurazioneCelle.elencoCelle[j].ingombroX;
      }
      if(this.configurazioneCelle.elencoCelle[j].lato_raccordo_prec=='lato_sn'){
        this.configurazioneCelle.elencoCelle[j].cx= this.configurazioneCelle.elencoCelle[j-1].cx-this.configurazioneCelle.elencoCelle[j].ingombroY;
        this.configurazioneCelle.elencoCelle[j].cy= this.configurazioneCelle.elencoCelle[j-1].cy;
        larghComplessiva+=this.configurazioneCelle.elencoCelle[j].ingombroY;
      }
      if(this.configurazioneCelle.elencoCelle[j].lato_raccordo_prec=='lato_ds'){
        this.configurazioneCelle.elencoCelle[j].cx= this.configurazioneCelle.elencoCelle[j-1].cx-this.configurazioneCelle.elencoCelle[j-1].ingombroY;
        this.configurazioneCelle.elencoCelle[j].cy= this.configurazioneCelle.elencoCelle[j-1].cy;
         larghComplessiva+=this.configurazioneCelle.elencoCelle[j].ingombroY;
      }
      

    }
    let minX=100; // fittizio 
    let minY=100; // fittizio 
    this.cellaperLabel=0;
    
    this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
      if(c.cx<minX){
        minX=c.cx;
        if(minX<0){
          this.cellaperLabel=ind;
        }
     
      }
      if(c.cy<minY){
        minY=c.cy;
        if(minY<0){
          this.cellaperLabel=ind;
        }
   
      }
    });
    

    this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
      c.cx+=Math.abs(minX);
      c.cy+=Math.abs(minY);
    });
    pdfW=Math.round(paginaW/1.6);
    pdfH=Math.round(paginaH/(1.6));
    pdfX=Math.round((paginaW-pdfW)/2);
    factor=pdfW/larghComplessiva;
    factorY=pdfH/lunghComplessiva;
    if(factor>factorY){
      factor=factorY;
      pdfW=factorY*larghComplessiva;
      pdfX=Math.round((paginaW-pdfW)/2);
    } else {
      factorY=factor;
    }
   

    
  }
   
  if(what=='all'){
    pdfX+=paginaW*0.6;
    filename=this.lang.el('Tavole disegni');
    label=this.lang.el('Piano soffitto');
    this.drawTavolaPdf(factor,factorY,'soffitto',label,pdfW,pdfX,pdfY,larghComplessiva,lunghComplessiva,formato);
   
    pdfY+=paginaH;
    label=this.lang.el('Piano pareti');
    this.drawTavolaPdf(factor,factorY,'pareti',label,pdfW,pdfX,pdfY,larghComplessiva,lunghComplessiva,formato);
    label=this.lang.el('Piano pavimento');
    pdfX+=paginaW*1.5;
    this.drawTavolaPdf(factor,factorY,'pavimento',label,pdfW,pdfX,pdfY,larghComplessiva,lunghComplessiva,formato);
    
  }
  if(what=='soffitto'){
    filename=this.lang.el('Piano soffitto');
    label=this.lang.el('Piano soffitto');
    this.drawTavolaPdf(factor,factorY,'soffitto',label,pdfW,pdfX,pdfY,larghComplessiva,lunghComplessiva,formato);
  }

  if(what=='pareti'){
    filename=this.lang.el('Piano pareti');
    label=this.lang.el('Piano pareti');
    
    this.drawTavolaPdf(factor,factorY,'pareti',label,pdfW,pdfX,pdfY,larghComplessiva,lunghComplessiva,formato);
  }

  if(what=='pavimento'){
    filename=this.lang.el('Piano pavimento');
    label=this.lang.el('Piano pavimento');
    this.drawTavolaPdf(factor,factorY,'pavimento',label,pdfW,pdfX,pdfY,larghComplessiva,lunghComplessiva,formato);
  }


  this.pdf.save(filename+'.pdf');

}

drawCartiglio(formato:string){
  if(formato!='a4' && formato!='a3') {
    return;
  }
  let mw=Math.round(this.pdf.internal.pageSize.getWidth()/20);
  let mh=Math.round(this.pdf.internal.pageSize.getHeight()/20);
  this.pdf.rect(mw, mh, this.pdf.internal.pageSize.getWidth()-mw*2,  this.pdf.internal.pageSize.getHeight()-mh*2);

  let hc=Math.round(this.pdf.internal.pageSize.getHeight()/50);
  let wc=(this.pdf.internal.pageSize.getWidth()-mw*2)/10;

  let cx=mw;
   if( formato=='a3') {
    cx=mw+Math.round((this.pdf.internal.pageSize.getWidth()-mw*2)/2);
    wc=Math.round((this.pdf.internal.pageSize.getWidth()-mw*2)/2)/10;
  }
  // linee orizz
  let cy=this.pdf.internal.pageSize.getHeight()-mh-hc*6.5;
  if( formato=='a3') {
    this.pdf.line(cx,cy,cx,cy+hc*6.5);
  }
  this.pdf.line(cx,cy,cx+wc*10,cy);
  cy+=hc;
  this.pdf.line(cx,cy,cx+wc*6,cy);
  cy+=hc;
  this.pdf.line(cx,cy,cx+wc*6,cy);
  cy+=hc;
  this.pdf.line(cx,cy,cx+wc*10,cy);
  cy+=hc;
  this.pdf.line(cx,cy,cx+wc*2,cy);
  this.pdf.line(cx+wc*6,cy,cx+wc*10,cy);
  cy+=hc;
  this.pdf.line(cx,cy,cx+wc*2,cy);
  this.pdf.line(cx+wc*6,cy,cx+wc*10,cy);
  cy+=hc;
  this.pdf.line(cx,cy,cx+wc*10,cy);

  // linee vert
  cy=this.pdf.internal.pageSize.getHeight()-mh-hc*6.5;
  this.pdf.line(cx+wc,cy,cx+wc,cy+hc*4);
  this.pdf.line(cx+wc*2,cy,cx+wc*2,cy+hc*6);
  this.pdf.line(cx+wc*5,cy,cx+wc*5,cy+hc*3);
  this.pdf.line(cx+wc*6,cy,cx+wc*6,cy+hc*6);
  this.pdf.line(cx+wc*8,cy+hc*3,cx+wc*8,cy+hc*4);
  cy=this.pdf.internal.pageSize.getHeight()-mh-hc*6.5;
  this.cellText(this.lang.el('Indice'),cx,cy+hc*2,wc,hc,11);
  this.cellText(this.lang.el('Auteur'),cx+wc,cy+hc*2,wc,hc,11);
  this.cellText(this.lang.el('Modifications'),cx+wc*2,cy+hc*2,wc*3,hc,11);
  this.cellText(this.lang.el('Date'),cx+wc*5,cy+hc*2,wc,hc,11);
  this.cellText(this.lang.el('Echelle'),cx,cy+hc*3,wc,hc*0.6,8);
  this.cellText(this.lang.el('Tolérance'),cx+wc,cy+hc*3,wc,hc*0.6,8);  
  this.cellText(this.lang.el('Auteur'),cx+wc*6,cy+hc*3,wc*2,hc*0.6,8);
  this.cellText(this.lang.el('Date'),cx+wc*8,cy+hc*3,wc*2,hc*0.6,8);

  this.cellText('A4',cx+wc*6,cy+hc*4,wc/2,hc,12);
  this.pdf.line(cx+wc*7,cy+hc*4,cx+wc*7,cy+hc*5);
  this.cellText(this.lang.el('Planche'),cx+wc*7,cy+hc*4,wc,hc*0.6,8);
  this.pdf.line(cx+wc*8,cy+hc*4,cx+wc*8,cy+hc*5);
  this.cellText(this.lang.el('Plan'),cx+wc*8,cy+hc*4,wc,hc*0.6,8);
  this.pdf.line(cx+wc*9,cy+hc*4,cx+wc*9,cy+hc*5);
  this.cellText(this.lang.el('Ind'),cx+wc*9,cy+hc*4,wc,hc*0.6,8);

  this.cellText(this.lang.el('Code'),cx+wc*6,cy+hc*5,wc,hc,11);


  this.cellText(this.lang.el('Ce plan est la propriété de Dagard. Il ne peut être modifié, reproduit ou communiqué à des tiers sans autorisation écrite.'),cx,cy+hc*6,wc*9,hc/2,6);
  this.cellText(this.lang.el('Page'),cx+wc*9,cy+hc*6,wc/2,hc/2,8);


}

cellText(txt:string,x:number,y:number,w:number,h:number,size:number){
  this.pdf.setFont("courier");
  this.pdf.setFontSize(size).setFont(undefined, 'normal').text(txt,x+w/2-this.pdf.getTextWidth(txt)/2,y+h/1.4,{
          align: 'left'
        });
}

drawPdf(factor:number,factorY:number,pdfX:number,pdfY:number,pdfW:number,
  titolo:string,disegno:string,larghConf:number,altezzaConf:number,formato:string){
  var context = this.pdf.context2d;
  context.lineWidth =.1;
 
  
  let cx:number=pdfX;
  let cy:number=pdfY;
 // factor=pdfW/this.mS.objCella.w;
 if(titolo!=''){
  this.pdf.setFont("courier");
  this.pdf.setFontSize(12).setFont(undefined, 'normal').text(titolo,cx+pdfW/2-this.pdf.getTextWidth(titolo),cy-15,{
          align: 'left'
        });
 }
 
  
  this.drawCartiglio(formato);

  if(disegno=='soffitto'){
    let last=0;
    this.mS.objSoffitto.pannelli.filter((x:any)=>x.side=='soffitto').forEach((p:any) => {
       if(!this.mS.cellaDati.ruotasoffitto){
        if(p.z && p.z>0){
          this.pdf.rect(cx,cy+p.z*factor,p.w*factor,p.h*factor);
          this.pdf.setFontSize(8).setFont(undefined, 'normal').text((p.w*10).toString()+'x'+(p.h*10).toString(),cx+p.w*factor/2,cy+p.z*factor+p.h*factor/2+this.pdf.getTextWidth((p.w*10).toString()+'x'+(p.h*10).toString())/2,{
            align: 'left',
            angle:90
          });
        } else {
          cx+=last;
          this.pdf.rect(cx,cy,p.w*factor,p.h*factor);
          this.pdf.setFontSize(8).setFont(undefined, 'normal').text((p.w*10).toString()+'x'+(p.h*10).toString(),cx+p.w*factor/2,cy+p.h*factor/2+this.pdf.getTextWidth((p.w*10).toString()+'x'+(p.h*10).toString())/2,{
            align: 'left',
            angle:90
          });
        }
        last=p.w*factor;
      }else {
        if(p.x && p.x>0){
            this.pdf.rect(cx+p.x*factor,cy,p.w*factor,p.h*factor);
            this.pdf.setFontSize(8).setFont(undefined, 'normal').text((p.w*10).toString()+'x'+(p.h*10).toString(),cx+p.x*factor+p.w*factor/2-this.pdf.getTextWidth((p.w*10).toString()+'x'+(p.h*10).toString())/2,cy+p.h*factor/2,{
              align: 'left'

            });
          } else {
            cy+=last;
            this.pdf.rect(cx,cy,p.w*factor,p.h*factor);
            this.pdf.setFontSize(8).setFont(undefined, 'normal').text((p.w*10).toString()+'x'+(p.h*10).toString(),cx+p.w*factor/2-this.pdf.getTextWidth((p.w*10).toString()+'x'+(p.h*10).toString())/2,cy+p.h*factor/2,{
              align: 'left'

            });
        }
        last=p.h*factor;
      }

      /*
      if(!this.mS.cellaDati.ruotasoffitto){
        
        if(p.z && p.z>0){
          zPannello=this.mS.objSoffitto.z+p.z;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        } else {
          zPannello=this.mS.objSoffitto.z;
          xPannello+=last;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        }
        last=p.w;
      }else {
        if(p.x && p.x>0){
          xPannello=this.mS.objSoffitto.x+p.x;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
        } else {
          xPannello=this.mS.objSoffitto.x;
          this.drawPanel(xPannello,yPannello,zPannello,p,'soffitto');
          zPannello+=last;
        }
        last=p.h;
      }
      */


    });
  }
  if(disegno=='pavimento'){
    let last=0;
    this.mS.objPavimento.pannelli.filter((x:any)=>x.side=='pavimento').forEach((p:any) => {    
      if(p.z && p.z>0){
        this.pdf.rect(cx,cy+p.z*factor,p.w*factor,p.h*factor);
        this.pdf.setFontSize(8).setFont(undefined, 'normal').text((p.w*10).toString()+'x'+(p.h*10).toString(),cx+p.w*factor/2,cy+p.z*factor+p.h*factor/2+this.pdf.getTextWidth((p.w*10).toString()+'x'+(p.h*10).toString())/2,{
            align: 'left',
            angle:90
          });
      } else {
        cx+=last;
        this.pdf.rect(cx,cy,p.w*factor,p.h*factor);
        this.pdf.setFontSize(8).setFont(undefined, 'normal').text((p.w*10).toString()+'x'+(p.h*10).toString(),cx+p.w*factor/2,cy+p.h*factor/2+this.pdf.getTextWidth((p.w*10).toString()+'x'+(p.h*10).toString())/2,{
            align: 'left',
            angle:90
          });
      }
      last=p.w*factor;
      

    });
  }
  
  cx=pdfX;
  cy=pdfY;
  this.pdf.setFontSize(8).setFont(undefined, 'normal');
  
  if(disegno=='pareti'){
    let curx=cx;
    let cury=cy;
    let dim=this.pdf.getTextDimensions('1200');
    this.mS.objLatSin.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any,ind:number) => {
      this.pdf.rect(curx,cury,p.w*factor,-1*p.d*factor);
      this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-this.pdf.getTextWidth((p.w*10).toString())/2,cy-dim.h,{
          align: 'left',
      });
      if(p.porta){       
        if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx,cury-1*p.d*factor,p.w*factor,-1*p.d*factor/2);
              this.pdf.rect(curx+p.w*factor-manigliaw,cury-1*p.d*factor/2*3,manigliaw,-manigliah);
              context.beginPath();
              context.arc(curx, cury-1*p.d*factor, p.w*factor,-1*Math.PI/2,0,false);
              context.stroke();
              this.pdf.line(curx,cury-1*p.d*factor,curx,cury-1*p.d*factor-p.w*factor);
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx,cury-1*p.d*factor,p.w*factor,-1*p.d*factor/2);
              this.pdf.rect(curx,cury-1*p.d*factor/2*3,manigliaw,-manigliah);
              context.beginPath();
              context.arc(curx+p.w*factor, cury-1*p.d*factor, p.w*factor,-1*Math.PI,-1*Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx+p.w*factor,cury-1*p.d*factor,curx+p.w*factor,cury-1*p.d*factor-p.w*factor);
          }
        }
       
      }
      curx+=p.w*factor;
    });
    curx=cx;
    cury=cy+this.mS.objCella.d*factor;

    this.mS.objLatDs.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any) => {
      this.pdf.rect(curx,cury,p.w*factor,p.d*factor);
      this.pdf.text((p.w*10).toString(),curx+p.w*factor/2-this.pdf.getTextWidth((p.w*10).toString())/2,cury+dim.h*1.5,{
          align: 'left',
      });
      if(p.porta){
           if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx,cury+p.d*factor,p.w*factor,p.d*factor/2);
              this.pdf.rect(curx,cury+1*p.d*factor/2*3,manigliaw,manigliah);
              context.beginPath();
              context.arc(curx+p.w*factor, cury+1*p.d*factor, p.w*factor,Math.PI/2,Math.PI,false);
              context.stroke();
              this.pdf.line(curx+p.w*factor,cury+p.d*factor,curx+p.w*factor,cury+1*p.d*factor+p.w*factor);
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/20;
              this.pdf.rect(curx,cury+p.d*factor,p.w*factor,p.d*factor/2);
              this.pdf.rect(curx+p.w*factor-manigliaw,cury+p.d*factor/2*3,manigliaw,manigliah);
              context.beginPath();
              context.arc(curx, cury+p.d*factor, p.w*factor,0,Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx,cury+p.d*factor,curx,cury+p.d*factor+p.w*factor);
          }
        }
      }
      curx+=p.w*factor;
    });
    curx=cx;
    cury=cy;

    this.mS.objFronte.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any) => {
      this.pdf.rect(curx,cury,-1*p.d*factor,p.w*factor);
      this.pdf.text((p.w*10).toString(),curx-dim.h,cury+p.w*factor/2,{
          align: 'left',
          angle:90
      });
      if(p.porta){
        if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx-p.d*factor,cury,-p.d*factor/2,p.w*factor);
              this.pdf.rect(curx-p.d*factor-p.d*factor/2,cury,-manigliah,manigliaw);
              context.beginPath();
              context.arc(curx-p.d*factor, cury+p.w*factor, p.w*factor,-1*Math.PI,-1*Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx-p.d*factor,cury+p.w*factor,curx-p.w*factor-p.d*factor,cury+p.w*factor);
            } else {
               let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx-p.d*factor,cury,-p.d*factor/2,p.w*factor);
              this.pdf.rect(curx-p.d*factor-p.d*factor/2,cury+p.w*factor,-manigliah,-manigliaw);
              context.beginPath();
              context.arc(curx-p.d*factor, cury, p.w*factor,Math.PI/2,Math.PI,false);
              context.stroke();
              this.pdf.line(curx-p.d*factor,cury,curx-p.w*factor-p.d*factor,cury);
          }
        }
      }
      cury+=p.w*factor;
    });
    curx=cx+this.mS.objCella.w*factor;
    cury=cy;
    this.mS.objRetro.pannelli.filter((x:any)=> !x.fittizio).forEach((p:any) => {
      this.pdf.rect(curx,cury,p.d*factor,p.w*factor);
      this.pdf.text((p.w*10).toString(),curx+dim.h*1.5,cury+p.w*factor/2,{
          align: 'left',
          angle:90
      });
       if(p.porta){
        if(!p.porta.scorrevole){
            if(p.porta.tipoApertura!='SX'){
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx+p.d*factor,cury,p.d*factor/2,p.w*factor);
              this.pdf.rect(curx+p.d*factor+p.d*factor/2,cury+p.w*factor,manigliah,-manigliaw);
              context.beginPath();
              context.arc(curx+p.d*factor, cury, p.w*factor,0,Math.PI/2,false);
              context.stroke();
              this.pdf.line(curx,cury,curx+p.w*factor,cury);

              
            } else {
              let manigliaw=p.w*factor/8;
              let manigliah=p.w*factor/30;
              this.pdf.rect(curx+p.d*factor,cury,p.d*factor/2,p.w*factor);
              this.pdf.rect(curx+p.d*factor+p.d*factor/2,cury,manigliah,manigliaw);
              context.beginPath();
              context.arc(curx+p.d*factor, cury+p.w*factor, p.w*factor,-1*Math.PI/2,0,false);
              context.stroke();
              this.pdf.line(curx,cury+p.w*factor,curx+p.w*factor,cury+p.w*factor);
          }
        }
      }
      cury+=p.w*factor;
    });
    
  

  } else {

    //lato fronte
    this.pdf.rect(cx,cy,this.mS.objCella.w*factor,-1*this.mS.objCella.spessore*factor);
    //lato ds
    this.pdf.rect(cx+this.mS.objCella.w*factor,cy,this.mS.objCella.spessore*factor,this.mS.objCella.d*factor);
    //lato sn
    this.pdf.rect(cx,cy,-1*this.mS.objCella.spessore*factor,this.mS.objCella.d*factor);
    //lato retro
    this.pdf.rect(cx,cy+this.mS.objCella.d*factor,this.mS.objCella.w*factor,this.mS.objCella.spessore*factor);

  }
  
  if(larghConf>0 && altezzaConf>0){
    this.drawMisuraSinistra(cx,cy,factor,factor,larghConf,altezzaConf);
    this.drawMisureSotto(cx,cy,factor,factor,larghConf,altezzaConf);
  }  

  context.beginPath();
  context.arc(cx, cy, this.mS.objCella.spessore*factor,-1*Math.PI,-1*Math.PI/2,false);
  context.stroke();
  context.beginPath();
  context.arc(cx+this.mS.objCella.w*factor, cy, this.mS.objCella.spessore*factor,-1*Math.PI/2,0,false);
  context.stroke();
  context.beginPath();
  context.arc(cx+this.mS.objCella.w*factor, cy+this.mS.objCella.d*factor, this.mS.objCella.spessore*factor,0,Math.PI/2,false);
  context.stroke();
  context.beginPath();
  context.arc(cx, cy+this.mS.objCella.d*factor, this.mS.objCella.spessore*factor,Math.PI/2,Math.PI,false);
  context.stroke();
  
}

drawMisuraSinistra(cx:number,cy:number,factor:number,factorY:number,cellaW:number,cellaH:number){  
  // misure a destra
  let deltaX=this.mS.objCella.d*factor/10;
  let labelX=cellaH*factor/15;;
  this.pdf.line(cx-deltaX,cy,cx-deltaX-labelX,cy);
  this.pdf.line(cx-deltaX,cy-this.mS.objCella.spessore*factor,cx-deltaX-labelX*2,cy-this.mS.objCella.spessore*factor);

  this.pdf.line(cx-deltaX,cy+cellaH*factor,cx-deltaX-labelX,cy+cellaH*factor);
  this.pdf.line(cx-deltaX,cy+cellaH*factor+this.mS.objCella.spessore*factor,cx-deltaX-labelX*2,cy+cellaH*factor+this.mS.objCella.spessore*factor);

  this.pdf.line(cx-deltaX-labelX+deltaX/10,cy-this.mS.objCella.spessore*factor*2,cx-deltaX-labelX+deltaX/10,cy+cellaH*factor+this.mS.objCella.spessore*factor*2);
  this.pdf.line(cx-deltaX-labelX*2+deltaX/10,cy-this.mS.objCella.spessore*factor,cx-deltaX-labelX*2+deltaX/10,cy+cellaH*factor+this.mS.objCella.spessore*factor);

  this.obliquo(cx-deltaX-labelX+deltaX/10,cy,this.mS.objCella.spessore*factor,true);
  this.obliquo(cx-deltaX-labelX*2+deltaX/10,cy-this.mS.objCella.spessore*factor,this.mS.objCella.spessore*factor,true);
  this.obliquo(cx-deltaX-labelX+deltaX/10,cy-this.mS.objCella.spessore*factor,this.mS.objCella.spessore*factor,true);
  
  this.obliquo(cx-deltaX-labelX+deltaX/10,cy+cellaH*factor,this.mS.objCella.spessore*factor,true);
  this.obliquo(cx-deltaX-labelX*2+deltaX/10,cy+this.mS.objCella.spessore*factor+cellaH*factor,this.mS.objCella.spessore*factor,true);
  this.obliquo(cx-deltaX-labelX+deltaX/10,cy+this.mS.objCella.spessore*factor+cellaH*factor,this.mS.objCella.spessore*factor,true);

  this.legenda_obliqua(cx-deltaX-labelX+deltaX/10,cy-this.mS.objCella.spessore*factor/2,labelX,false,(this.mS.objCella.spessore*10).toString());

  this.legenda_obliqua(cx-deltaX-labelX+deltaX/10,cy+cellaH*factor+this.mS.objCella.spessore*factor/2,labelX,false,(this.mS.objCella.spessore*10).toString());


  this.pdf.setFontSize(8).setFont(undefined, 'normal').text(((cellaH+this.mS.objCella.spessore*2)*10).toString(),cx-deltaX-labelX*2,cy+cellaH*factor/2+this.pdf.getTextWidth(((cellaH+this.mS.objCella.spessore*2)*10).toString())/2,{
          align: 'left',
          angle:90
        });

  this.pdf.setFontSize(8).setFont(undefined, 'normal').text((cellaH*10).toString(),cx-deltaX-labelX,cy+cellaH*factor/2+this.pdf.getTextWidth((cellaH*10).toString())/2,{
          align: 'left',
          angle:90
        });
}

drawMisureSotto(cx:number,cy:number,factor:number,factorY:number,cellaW:number,cellaH:number){
// misure sotto
  let deltaY=this.mS.objCella.w*factor/10;
  let labelY=cellaW*factor/15;
  this.pdf.line(cx,cy+cellaH*factor+deltaY,cx,cy+cellaH*factor+deltaY+labelY+this.mS.objCella.spessore*factor);
  this.pdf.line(cx-this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY,cx-this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY+labelY*2);

  this.pdf.line(cx+cellaW*factor,cy+cellaH*factor+deltaY,cx+cellaW*factor,cy+cellaH*factor+deltaY+labelY+this.mS.objCella.spessore*factor);
  this.pdf.line(cx+cellaW*factor+this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY,cx+cellaW*factor+this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY+labelY*2+this.mS.objCella.spessore*factor);

  this.pdf.line(cx-this.mS.objCella.spessore*factor*2,cy+cellaH*factor+deltaY+labelY,cx+cellaW*factor+this.mS.objCella.spessore*factor*2,cy+cellaH*factor+deltaY+labelY);
  this.pdf.line(cx-this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY+labelY*2,cx+cellaW*factor+this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY+labelY*2);
 
  this.obliquo(cx-this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY+labelY,this.mS.objCella.spessore*factor,false);
  this.obliquo(cx,cy+cellaH*factor+deltaY+labelY,this.mS.objCella.spessore*factor,false);
  this.obliquo(cx-this.mS.objCella.spessore*factor,cy+cellaH*factor+deltaY+labelY*2,this.mS.objCella.spessore*factor,false);
  
  this.obliquo(cx+this.mS.objCella.spessore*factor+cellaW*factor,cy+cellaH*factor+deltaY+labelY,this.mS.objCella.spessore*factor,false);
  this.obliquo(cx+cellaW*factor,cy+cellaH*factor+deltaY+labelY,this.mS.objCella.spessore*factor,false);
  this.obliquo(cx+this.mS.objCella.spessore*factor+cellaW*factor,cy+cellaH*factor+deltaY+labelY*2,this.mS.objCella.spessore*factor,false);
  
  this.legenda_obliqua(cx-this.mS.objCella.spessore*factor/2,cy+cellaH*factor+deltaY+labelY,labelY,true,(this.mS.objCella.spessore*10).toString());
  
  this.legenda_obliqua(cx+cellaW*factor+this.mS.objCella.spessore*factor/2,cy+cellaH*factor+deltaY+labelY,labelY,true,(this.mS.objCella.spessore*10).toString());

  this.pdf.setFontSize(8).setFont(undefined, 'normal').text(((cellaW+this.mS.objCella.spessore*2)*10).toString()+"AAA",cx+cellaW*factor/2-this.pdf.getTextWidth(((cellaW+this.mS.objCella.spessore*2)*10).toString())/2,cy+cellaH*factor+deltaY+labelY*2.8,{
          align: 'left'
        });

  this.pdf.setFontSize(8).setFont(undefined, 'normal').text((cellaW*10).toString()+"BBB",cx+cellaW*factor/2-this.pdf.getTextWidth((cellaW*10).toString())/2,cy+cellaH*factor+deltaY+labelY*0.8,{
          align: 'left'
        });

}
legenda_obliqua(x:number,y:number,l:number,down:boolean,txt:string){
  const dim = this.pdf.getTextDimensions(txt);
  if(down){
    let x2=x+l/2;
    let y2=y+l*1.2;
    this.pdf.line(x,y,x2,y2);
    this.pdf.line(x2,y2,x2+l,y2);
    this.pdf.setFontSize(8).setFont(undefined, 'normal').text(txt,x2+l/2-this.pdf.getTextWidth(txt)/2,y2-dim.h*0.5,{
          align: 'left'
        });
  } else {
    let x2=x-l*1.2;
    let y2=y-l/2;
    this.pdf.line(x,y,x2,y2);
    this.pdf.line(x2,y2,x2,y2-l);
    this.pdf.setFontSize(8).setFont(undefined, 'normal').text(txt,x2-dim.h*0.5,y2-l/2+this.pdf.getTextWidth(txt)/2,{
        align: 'left',
        angle:90
    });
  }
}

obliquo(x:number,y:number,l:number,down:boolean){
  
  let ll=Math.round(l/2)*0.7;
  if(down){
    this.pdf.line(x-ll,y-ll,x+ll,y+ll);
  } else {
    this.pdf.line(x-ll,y+ll,x+ll,y-ll);
  }
 

}


}

